// @ts-nocheck
import {
  createUseReadContract,
  createUseWriteContract,
  createUseSimulateContract,
  createUseWatchContractEvent,
} from 'wagmi/codegen'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Dex
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const dexAbi = [
  { type: 'constructor', inputs: [], stateMutability: 'nonpayable' },
  {
    type: 'error',
    inputs: [
      { name: 'accountAddress', internalType: 'address', type: 'address' },
    ],
    name: 'AccountDoesNotExist',
  },
  {
    type: 'error',
    inputs: [
      { name: 'sender', internalType: 'address', type: 'address' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'AccountExists',
  },
  {
    type: 'error',
    inputs: [
      { name: 'status', internalType: 'enum FreezeStatusEnum', type: 'uint8' },
    ],
    name: 'AccountFrozen',
  },
  {
    type: 'error',
    inputs: [{ name: 'accountId', internalType: 'uint256', type: 'uint256' }],
    name: 'AccountIdDoesNotExist',
  },
  {
    type: 'error',
    inputs: [{ name: 'addr', internalType: 'address', type: 'address' }],
    name: 'AddressBlocked',
  },
  {
    type: 'error',
    inputs: [
      { name: 'amountCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'availableBalanceCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'balanceCNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'AmountExceedsAvailableBalance',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
      },
      { name: 'bankruptcyPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'markPricePNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'BankruptcyPricePreventsDeleverage',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'buyer', internalType: 'address', type: 'address' },
    ],
    name: 'BuyToLiquidateBuyerRestricted',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'insAmtPer100K', internalType: 'uint256', type: 'uint256' },
      { name: 'userAmtPer100K', internalType: 'uint256', type: 'uint256' },
      { name: 'buyerAmtPer100K', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'BuyToLiquidateParamsExceedUnity',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'posAccountId', internalType: 'uint256', type: 'uint256' },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
      },
      { name: 'markPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'limitPricePNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'BuyToLiquidateSlippageExceeded',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'lockedLotLNS', internalType: 'uint256', type: 'uint256' },
      {
        name: 'lockedPositionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
      },
      {
        name: 'newPositionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
      },
    ],
    name: 'CancelExistingInvalidCloseOrders',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'numOrders', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'CancelOrdersBeforeRemovingContract',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'orderId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'CannotChangeCloseOrderLocks',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'posAccountId', internalType: 'uint256', type: 'uint256' },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
      },
      { name: 'markPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'bsLiqPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'liqPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'bkptPricePNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'CantBuyToLiquidate',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'orderId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'CantChangeCloseOrder',
  },
  { type: 'error', inputs: [], name: 'CantClearNullOrderId' },
  {
    type: 'error',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'CantClearSlotsOnExistingPerp',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'forceClose', internalType: 'bool', type: 'bool' },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
      },
      { name: 'deleveragePricePNS', internalType: 'uint256', type: 'uint256' },
      {
        name: 'sortedPositionIds',
        internalType: 'uint256[]',
        type: 'uint256[]',
      },
    ],
    name: 'CantDeleverageAgainstOpposingPositions',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'posAccountId', internalType: 'uint256', type: 'uint256' },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
      },
      { name: 'lotSize', internalType: 'uint256', type: 'uint256' },
      { name: 'realizedPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'realizedFmvCNS', internalType: 'int256', type: 'int256' },
    ],
    name: 'CantLiquidateInsolventPos',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'posAccountId', internalType: 'uint256', type: 'uint256' },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
      },
      { name: 'markPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'liqPricePNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'CantLiquidatePosAboveMMR',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'posAccountId', internalType: 'uint256', type: 'uint256' },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
      },
      { name: 'fillPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'liqPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'bkptPricePNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'CantLiquidatePosOnBookSevere',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'orderType', internalType: 'enum OrderEnum', type: 'uint8' },
      { name: 'pricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'lotLNS', internalType: 'uint256', type: 'uint256' },
      { name: 'reason', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'CantPostOrder',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'orderId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'expiryBlock', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ChangeExpiredOrderNeedsNewExpiry',
  },
  {
    type: 'error',
    inputs: [
      { name: 'posLotLNS', internalType: 'uint256', type: 'uint256' },
      { name: 'orderLotLNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'CloseOrderExceedsPosition',
  },
  {
    type: 'error',
    inputs: [
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
      },
      { name: 'orderType', internalType: 'enum OrderEnum', type: 'uint8' },
    ],
    name: 'CloseOrderPositionMismatch',
  },
  {
    type: 'error',
    inputs: [
      { name: 'requested', internalType: 'uint256', type: 'uint256' },
      { name: 'max', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ConfigEntryLimit',
  },
  {
    type: 'error',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'ContractCannotBeRemoved',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'collateralDecimals', internalType: 'uint256', type: 'uint256' },
      { name: 'priceDecimals', internalType: 'uint256', type: 'uint256' },
      { name: 'lotDecimals', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ContractDecimalsExceedResolution',
  },
  {
    type: 'error',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'ContractDoesNotExist',
  },
  {
    type: 'error',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'ContractIdExceedsMaximum',
  },
  {
    type: 'error',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'ContractIdInUse',
  },
  {
    type: 'error',
    inputs: [
      { name: 'balanceCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'requestCNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ContractInsufficientFunds',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'status', internalType: 'enum PerpStatusEnum', type: 'uint8' },
    ],
    name: 'ContractNotOperational',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'status', internalType: 'enum PerpStatusEnum', type: 'uint8' },
    ],
    name: 'ContractNotPaused',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'status', internalType: 'enum PerpStatusEnum', type: 'uint8' },
    ],
    name: 'ContractNotUnwindPrepared',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'perpPositionBalCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'perpInsuranceBalCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'amountCNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'CriticalPerpetualInsolvent',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'pricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'isBid', internalType: 'bool', type: 'bool' },
      { name: 'minAskOrMaxBidPNS', internalType: 'uint256', type: 'uint256' },
      { name: 'maxOrdersChecked', internalType: 'bool', type: 'bool' },
    ],
    name: 'CrossesBook',
  },
  {
    type: 'error',
    inputs: [
      {
        name: 'dcpBorrowThreshHdths',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'unityDescentThreshHdths',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    name: 'DcpBorrowMustBeLessThanUnityDescent',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'DecreaseCollateralRequestDoesNotExist',
  },
  {
    type: 'error',
    inputs: [
      { name: 'decrement', internalType: 'uint256', type: 'uint256' },
      { name: 'minuend', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'DecrementUnderflows',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'DeleveragePositionListEmpty',
  },
  {
    type: 'error',
    inputs: [
      { name: 'value1', internalType: 'uint256', type: 'uint256' },
      { name: 'value2', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'DifferenceExceedsInt256',
  },
  {
    type: 'error',
    inputs: [
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'decrement', internalType: 'uint256', type: 'uint256' },
      { name: 'maximum', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'DifferenceExceedsMaximum',
  },
  {
    type: 'error',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'DuplicatePerpIdInConfig',
  },
  {
    type: 'error',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'DuplicatePerpIdInResidueXfers',
  },
  {
    type: 'error',
    inputs: [
      { name: 'lastExecutionBlock', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ExceedsLastExecutionBlock',
  },
  { type: 'error', inputs: [], name: 'ExchangeHalted' },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'blockNumber', internalType: 'uint256', type: 'uint256' },
      { name: 'fundingEventBlock', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'FundingEventSetTooEarly',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'entryBlock', internalType: 'uint256', type: 'uint256' },
      { name: 'exitBlock', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'FundingExitBlockPreceedsEntryBlock',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'fundingPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'oraclePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'tolerancePer100k', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'FundingPriceExceedsTol',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'fundingEventBlock', internalType: 'uint256', type: 'uint256' },
      { name: 'storageIndex', internalType: 'uint256', type: 'uint256' },
      { name: 'fundingSumOffset', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'FundingSumAlreadySet',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'orderAmountCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'minAmountCNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ImmediateOrderUnderMinimum',
  },
  {
    type: 'error',
    inputs: [
      { name: 'tokenAddress', internalType: 'address', type: 'address' },
      { name: 'tokenDecimals', internalType: 'uint256', type: 'uint256' },
      {
        name: 'expectedTokenDecimals',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    name: 'IncompatibleCollateralToken',
  },
  {
    type: 'error',
    inputs: [
      { name: 'initMarginFracHdths', internalType: 'uint256', type: 'uint256' },
      {
        name: 'maintMarginFracHdths',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    name: 'InitialMarginFractionEqualsOrExceedsMaintenance',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'posAccountId', internalType: 'uint256', type: 'uint256' },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
      },
      { name: 'bankruptcyPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'markPricePNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'InsolventPositionCannotBeForcedClose',
  },
  {
    type: 'error',
    inputs: [
      { name: 'sender', internalType: 'address', type: 'address' },
      { name: 'amountCNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'InsufficentAmountToOpenAccount',
  },
  {
    type: 'error',
    inputs: [
      { name: 'balanceCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'amountCNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'InsufficientFunds',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'balanceCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'lockedCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'recycleFeeCNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'InsuficientFundsForRecycleFee',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'depositCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'posPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'liqLotLNS', internalType: 'uint256', type: 'uint256' },
      { name: 'premiumPnlCNS', internalType: 'int256', type: 'int256' },
    ],
    name: 'InvalidBankruptcyPrice',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      {
        name: 'proposedBorrowFracHdths',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'minMarginFracHdths', internalType: 'uint256', type: 'uint256' },
      { name: 'initMarginFracHdths', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'InvalidBorrowFraction',
  },
  {
    type: 'error',
    inputs: [
      { name: 'denominatorDecimals', internalType: 'uint256', type: 'uint256' },
      { name: 'minimum', internalType: 'uint256', type: 'uint256' },
      { name: 'maximum', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'InvalidDenominatorDecimals',
  },
  {
    type: 'error',
    inputs: [
      { name: 'expiryBlock', internalType: 'uint256', type: 'uint256' },
      { name: 'blockNumber', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'InvalidExpiryBlock',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'newExp', internalType: 'uint256', type: 'uint256' },
      { name: 'maxExp', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'InvalidFundingSumScalingExp',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'perpFeedId', internalType: 'bytes32', type: 'bytes32' },
      { name: 'reportFeedId', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'InvalidLinkReportForContract',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'reportVersion', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'InvalidLinkReportVersion',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'depositCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'posPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'liqLotLNS', internalType: 'uint256', type: 'uint256' },
      { name: 'premiumPnlCNS', internalType: 'int256', type: 'int256' },
    ],
    name: 'InvalidLiquidationPrice',
  },
  {
    type: 'error',
    inputs: [
      { name: 'minCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'maxCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'proposedCNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'InvalidMinWithdrawLimit',
  },
  {
    type: 'error',
    inputs: [
      { name: 'orderId', internalType: 'uint256', type: 'uint256' },
      { name: 'min', internalType: 'uint256', type: 'uint256' },
      { name: 'max', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'InvalidOrderId',
  },
  {
    type: 'error',
    inputs: [
      { name: 'orderType', internalType: 'enum OrderEnum', type: 'uint8' },
      { name: 'amountCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'lotLNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'InvalidOrderLock',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      {
        name: 'proposedInitMarginFracHdths',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'initMarginFracHdths', internalType: 'uint256', type: 'uint256' },
      {
        name: 'maintMarginFracHdths',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    name: 'InvalidProposedInitFraction',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      {
        name: 'proposedMaintMarginFracHdths',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'maintMarginFracHdths',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'initMarginFracHdths', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'InvalidProposedMaintFraction',
  },
  {
    type: 'error',
    inputs: [
      { name: 'minThousandths', internalType: 'uint256', type: 'uint256' },
      { name: 'maxThousandths', internalType: 'uint256', type: 'uint256' },
      { name: 'proposedThousandths', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'InvalidWithdrawLimitThousandths',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'verifierProxy', internalType: 'address', type: 'address' },
      { name: 'linkDsFeedId', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'LinkDsOracleNotConfigured',
  },
  {
    type: 'error',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'LinkDsPriceUninitialized',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      {
        name: 'liquidationType',
        internalType: 'enum OrderEnum',
        type: 'uint8',
      },
      { name: 'pricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'lotLNS', internalType: 'uint256', type: 'uint256' },
      { name: 'resultCode', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'LiquidationBuyerSettlementFailed',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'insAmtPer100K', internalType: 'uint256', type: 'uint256' },
      { name: 'liqAmtPer100K', internalType: 'uint256', type: 'uint256' },
      { name: 'userAmtPer100K', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'LiquidationParamsExceedUnity',
  },
  {
    type: 'error',
    inputs: [
      { name: 'lotLNS', internalType: 'uint256', type: 'uint256' },
      { name: 'minLotLNS', internalType: 'uint256', type: 'uint256' },
      { name: 'maxLotLNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'LotOutOfRange',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'markPNS', internalType: 'uint256', type: 'uint256' },
      { name: 'spotOraclePricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'tolerancePer100k', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'MarkExceedsTol',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'markTimestamp', internalType: 'uint256', type: 'uint256' },
      { name: 'timestamp', internalType: 'uint256', type: 'uint256' },
      { name: 'maxAgeSec', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'MarkPriceAgeExceedsMax',
  },
  {
    type: 'error',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'MarkPriceUninitialized',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'MaximumAccountOrders',
  },
  { type: 'error', inputs: [], name: 'NegativeDepositCheckFailedSevere' },
  { type: 'error', inputs: [], name: 'NoAccountsRemain' },
  {
    type: 'error',
    inputs: [{ name: 'addr', internalType: 'address', type: 'address' }],
    name: 'NotWhitelisted',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'NullOrderIdSpecifiedSevere',
  },
  {
    type: 'error',
    inputs: [
      { name: 'longOiLNS', internalType: 'uint256', type: 'uint256' },
      { name: 'shortOiLNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'OpenInterestInequalSevere',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'currentOiLNS', internalType: 'uint256', type: 'uint256' },
      { name: 'thresholdOiLNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'OpenInterestTooHighForDcp',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'oracleTimestamp', internalType: 'uint256', type: 'uint256' },
      { name: 'timestamp', internalType: 'uint256', type: 'uint256' },
      { name: 'maxAgeSec', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'OracleAgeExceedsMax',
  },
  {
    type: 'error',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'OrderBookFull',
  },
  {
    type: 'error',
    inputs: [
      { name: 'specifiedPriceONS', internalType: 'uint256', type: 'uint256' },
      { name: 'maxONS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'OrderBookPriceOutOfRange',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'orderId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'OrderDoesNotExist',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'orderId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'OrderDoesntExistSevere',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'specifiedPriceONS', internalType: 'uint256', type: 'uint256' },
      { name: 'orderId', internalType: 'uint256', type: 'uint256' },
      { name: 'orderPriceONS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'OrderIdIsNotAtSpecifiedPriceLevel',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'orderId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'OrderLockDoesntExistSevere',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'orderId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'OrderLockExistsSevere',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'orderType', internalType: 'enum OrderEnum', type: 'uint8' },
      { name: 'priceONS', internalType: 'uint256', type: 'uint256' },
      { name: 'lotLNS', internalType: 'uint256', type: 'uint256' },
      { name: 'isBid', internalType: 'bool', type: 'bool' },
    ],
    name: 'OrderPostFailed',
  },
  {
    type: 'error',
    inputs: [
      { name: 'orderLotLNS', internalType: 'uint256', type: 'uint256' },
      { name: 'availableLotLNS', internalType: 'uint256', type: 'uint256' },
      { name: 'positionLotLNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'OrderSizeExceedsAvailableSize',
  },
  {
    type: 'error',
    inputs: [{ name: 'premiumPnlCNS', internalType: 'int256', type: 'int256' }],
    name: 'OverflowPremiumCnsSevere',
  },
  {
    type: 'error',
    inputs: [
      {
        name: 'permissionlessCancelMinOrders',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'minimum', internalType: 'uint256', type: 'uint256' },
      { name: 'maximum', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'PermissionlessCancelOrdersOutOfRange',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'positionBalanceCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'insuranceBalanceCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'amountCNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'PerpInsolvencyCheckFailedSevere',
  },
  {
    type: 'error',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'PerpetualActivated',
  },
  {
    type: 'error',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'PerpetualNotActivated',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'PositionAlreadyInListSevere',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'forceClose', internalType: 'bool', type: 'bool' },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
      },
      { name: 'adlLotLNS', internalType: 'uint256', type: 'uint256' },
      { name: 'delevPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'markPricePNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'PositionCannotBeDeleveraged',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'PositionDoesNotExist',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'expected', internalType: 'enum PositionEnum', type: 'uint8' },
      { name: 'actual', internalType: 'enum PositionEnum', type: 'uint8' },
    ],
    name: 'PositionTypeMismatch',
  },
  {
    type: 'error',
    inputs: [
      { name: 'orderAmountCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'minAmountCNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'PostOrderUnderMinimum',
  },
  {
    type: 'error',
    inputs: [
      { name: 'priceDecimals', internalType: 'uint256', type: 'uint256' },
      { name: 'lotDecimals', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'PriceLotDecimalSumExceedsCollateralSevere',
  },
  {
    type: 'error',
    inputs: [
      { name: 'pricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'minPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'maxPricePNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'PriceOutOfRange',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'proposedFeePer100K', internalType: 'uint256', type: 'uint256' },
      { name: 'maxFeePer100K', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ProposedFeeExceedsMax',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      {
        name: 'proposedClampPctPer100k',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'maxClampPctPer100k', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ProposedFundingRateClampExceedsMax',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'proposedTol', internalType: 'uint256', type: 'uint256' },
      { name: 'maxTol', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ProposedMarginTolExceedsMax',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'proposedAgeSec', internalType: 'uint256', type: 'uint256' },
      { name: 'maxAgeSec', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ProposedPriceAgeExceedsMax',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'proposedTol', internalType: 'uint256', type: 'uint256' },
      { name: 'maxTolPer100k', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ProposedPriceTolExceedsMax',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'lastUpdateTimestamp', internalType: 'uint256', type: 'uint256' },
      {
        name: 'reportValidFromTimestamp',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    name: 'ReportAgeExceedsLastUpdate',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'expiresAt', internalType: 'uint256', type: 'uint256' },
      { name: 'minRequired', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ReportExpiresTooSoon',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'reportTimestamp', internalType: 'uint256', type: 'uint256' },
      { name: 'blockTimestamp', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ReportFromFuture',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'reportPrice', internalType: 'int256', type: 'int256' },
    ],
    name: 'ReportPriceIsNegative',
  },
  {
    type: 'error',
    inputs: [
      { name: 'requested', internalType: 'uint256', type: 'uint256' },
      { name: 'max', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ResidueTransferEntryLimit',
  },
  {
    type: 'error',
    inputs: [{ name: 'sender', internalType: 'address', type: 'address' }],
    name: 'SenderIsNotAdministrator',
  },
  {
    type: 'error',
    inputs: [{ name: 'sender', internalType: 'address', type: 'address' }],
    name: 'SenderIsNotMonitorAdministrator',
  },
  {
    type: 'error',
    inputs: [{ name: 'sender', internalType: 'address', type: 'address' }],
    name: 'SenderIsNotPositionAdministrator',
  },
  {
    type: 'error',
    inputs: [{ name: 'sender', internalType: 'address', type: 'address' }],
    name: 'SenderIsNotPriceAdministrator',
  },
  {
    type: 'error',
    inputs: [{ name: 'sender', internalType: 'address', type: 'address' }],
    name: 'SenderIsNotToleranceAdministrator',
  },
  {
    type: 'error',
    inputs: [
      { name: 'existingValue', internalType: 'uint256', type: 'uint256' },
      { name: 'increment', internalType: 'uint256', type: 'uint256' },
      { name: 'maximum', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'SumExceedsMaximum',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'entryPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'collatPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'pnlPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'filledLotLNS', internalType: 'uint256', type: 'uint256' },
      { name: 'unfillableLotLNS', internalType: 'uint256', type: 'uint256' },
      { name: 'resultCode', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'TakerOrderSettlementFailed',
  },
  {
    type: 'error',
    inputs: [
      { name: 'name', internalType: 'string', type: 'string' },
      { name: 'numBytes', internalType: 'uint256', type: 'uint256' },
      { name: 'maxBytes', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'TooManyBytesInName',
  },
  {
    type: 'error',
    inputs: [
      { name: 'symbol', internalType: 'string', type: 'string' },
      { name: 'numBytes', internalType: 'uint256', type: 'uint256' },
      { name: 'maxBytes', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'TooManyBytesInSymbol',
  },
  { type: 'error', inputs: [], name: 'UnfreezeAccountNotPermitted' },
  {
    type: 'error',
    inputs: [
      {
        name: 'unityDescentThreshHdths',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'overColDescentThreshHdths',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    name: 'UnityMustBeLessThanOverColDescent',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'unmatchedLotLNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'UnmatchedLotRemainsInFillOrKill',
  },
  { type: 'error', inputs: [], name: 'UnspecifiedCollateral' },
  {
    type: 'error',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'UnwindAlreadyInitialized',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      {
        name: 'perpStatus',
        internalType: 'enum PerpStatusEnum',
        type: 'uint8',
      },
    ],
    name: 'UnwindNotInitialized',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      {
        name: 'perpStatus',
        internalType: 'enum PerpStatusEnum',
        type: 'uint8',
      },
    ],
    name: 'UnwindNotPrepared',
  },
  {
    type: 'error',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'UnwindProcessInProgress',
  },
  {
    type: 'error',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'UnwindProcessStarted',
  },
  {
    type: 'error',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'UpdateOracleFailed',
  },
  {
    type: 'error',
    inputs: [
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'maximum', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ValueExceedsMaximum',
  },
  {
    type: 'error',
    inputs: [
      { name: 'value', internalType: 'uint256', type: 'uint256' },
      { name: 'minimum', internalType: 'uint256', type: 'uint256' },
      { name: 'maximum', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'ValueOutsideRange',
  },
  {
    type: 'error',
    inputs: [
      { name: 'amountCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'allowanceCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'amountPerBlockCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'expiryBlock', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'WithdrawRateLimitExceeded',
  },
  {
    type: 'error',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'orderId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'WrongAccountForOrder',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'account',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      { name: 'id', internalType: 'uint256', type: 'uint256', indexed: false },
    ],
    name: 'AccountCreated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'status',
        internalType: 'enum FreezeStatusEnum',
        type: 'uint8',
        indexed: false,
      },
    ],
    name: 'AccountFreeze',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'status',
        internalType: 'enum FreezeStatusEnum',
        type: 'uint8',
        indexed: false,
      },
    ],
    name: 'AccountFrozen',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'startBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'AccountLiquidationCredit',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousAdmin',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'newAdmin',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'AdminChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'administrator',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      { name: 'added', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'AdministratorUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'amountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'availableBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'AmountExceedsAvailableBalance',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'bankruptcyPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'markPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BankruptcyPricePreventsDeleverage',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'beacon',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'BeaconUpgraded',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'addr', internalType: 'address', type: 'address', indexed: true },
      { name: 'blocked', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'BlockStatusChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'bmrCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'fmvAfterCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
    ],
    name: 'BorrowMarginNotMetAfterDecCollateral',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'buyer',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'BuyToLiquidateBuyerRestricted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'insAmtPer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'userAmtPer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'buyerAmtPer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'protAmtPer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BuyToLiquidateParamsUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'restrictBuyers',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'BuyToLiquidateRestrictionUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderType',
        internalType: 'enum OrderEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'realizedPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'balanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BuyToLiquidateSettled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'posAccountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'markPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'limitPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BuyToLiquidateSlippageExceeded',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'posAccountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liquidatorId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'requestedLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'leverageHdths',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'limitPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'maxNegPnlCollatBPS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BuyToLiquidateStarted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'thresholdPer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'BuyToLiquidateThresholdUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'lockedLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lockedPositionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'newPositionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
    ],
    name: 'CancelExistingInvalidCloseOrders',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'adjustmentAmountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'entryPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'adjustedEntryPricePNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
    ],
    name: 'CannotAdjustEntryPriceToDecCollateral',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'posAccountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'markPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'bsLiqPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liqPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'bkptPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'CantBuyToLiquidate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'CantChangeCloseOrder',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'forceClose',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'deleveragePricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'sortedPositionIds',
        internalType: 'uint256[]',
        type: 'uint256[]',
        indexed: false,
      },
    ],
    name: 'CantDeleverageAgainstOpposingPositions',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'posAccountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'markPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liqPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'CantLiquidatePosAboveMMR',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'expiryBlock',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ChangeExpiredOrderNeedsNewExpiry',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lockedBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recyclerAccountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recyclerAmountCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'recyclerBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ClearingExpiredOrder',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lockedBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recyclerAccountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recyclerAmountCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'recyclerBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ClearingFrozenAccountOrder',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lockedBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recyclerAccountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recyclerAmountCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'recyclerBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ClearingInvalidCloseOrder',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'pricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'remainingLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lockedBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'excessiveLockedBalCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recyclerAccountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recyclerAmountCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'recyclerBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ClearingRemainingOrderLockBeyondBalance',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lockedBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recyclerAccountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recyclerAmountCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'recyclerBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ClearingSelfMatchingOrder',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'posLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'CloseOrderExceedsPosition',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'orderType',
        internalType: 'enum OrderEnum',
        type: 'uint8',
        indexed: false,
      },
    ],
    name: 'CloseOrderPositionMismatch',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'reason',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
    ],
    name: 'CollateralDecreaseDeclined',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'CollateralDecreaseRequestCancelled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'expiryTS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'blockTS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'CollateralDecreaseRequestExpired',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'expiryTS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'clampToMaximum',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'entryPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'CollateralDecreaseRequested',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'CollateralDeposit',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'CollateralWithdrawal',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'name', internalType: 'string', type: 'string', indexed: false },
      {
        name: 'symbol',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
      {
        name: 'status',
        internalType: 'enum PerpStatusEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'basePricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'priceDecimals',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lotDecimals',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'takerFeePer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'makerFeePer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'initMarginFracHdths',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'maintMarginFracHdths',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'maxOpenInterestLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'unityDescentThreshHdths',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'overColDescentThreshHdths',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'dcpBorrowThreshHdths',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'priceTolPer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'marginTol',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'marginTolDecimals',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'refPriceMaxAgeSec',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'absFundingClampPctPer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'permCancelMinOrders',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'permCancelSegment',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'insAmtPer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liqInsAmtPer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liqUserAmtPer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'btlRestrictBuyers',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
      {
        name: 'btlPriceThreshPer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'btlInsAmtPer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'btlUserAmtPer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'btlBuyerAmtPer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'numPerpetuals',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ContractAdded',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'feedId',
        internalType: 'bytes32',
        type: 'bytes32',
        indexed: false,
      },
    ],
    name: 'ContractLinkFeedUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'status',
        internalType: 'enum PerpStatusEnum',
        type: 'uint8',
        indexed: false,
      },
    ],
    name: 'ContractNotOperational',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'paused', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ContractPaused',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ContractRemoved',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'minAskOrMaxBidPNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'maxOrdersChecked',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'CrossesBook',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'threshHdths',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'DcpBorrowThreshUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'impactAdjPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'markPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'DecreaseCollateralBeyondMarkPrice',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'DeleveragePositionListEmpty',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'lastExecutionBlock',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ExceedsLastExecutionBlock',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'halted', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ExchangeHalted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'sender',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'collateralToken',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'collateralDecimals',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'minAccountOpenCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'wrlsThousandthsTvl',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'wrlsMinWithdrawLimitCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recycleFeeCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'whitelistingEnabled',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'ExchangeInitialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'insAmtPer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'FeeParamsUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'clampPctPer100k',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'FundingClampPctUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'fundingEventBlock',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'specifiedRatePct100k',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'actualRatePct100k',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'fundingPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'fundingPaymentPNS',
        internalType: 'int48',
        type: 'int48',
        indexed: false,
      },
      {
        name: 'fundingSumPNS',
        internalType: 'int48',
        type: 'int48',
        indexed: false,
      },
      {
        name: 'allowOverwrite',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'FundingEventCompleted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'blockNumber',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'fundingEventBlock',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'FundingEventSetTooEarly',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'fundingPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'oraclePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'tolerancePer100k',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'FundingPriceExceedsTol',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'fundingEventBlock',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'storageIndex',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'fundingSumOffset',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'FundingSumAlreadySet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newExp',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'FundingSumScalingExpUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'ignOracle', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'IgnoreOracleUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'unmatchedLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'totalLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ImmediateOrCancelExecuted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionDepositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'IncreasePositionCollateral',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'initMarginFracHdths',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'InitialMarginFractionUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'version', internalType: 'uint8', type: 'uint8', indexed: false },
    ],
    name: 'Initialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'posAccountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'bankruptcyPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'markPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'InsolventPositionCannotBeForcedClose',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'withdrawMaxCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'InsufficientFundsToDecCollateral',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lockedCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recycleFeeCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'InsuficientFundsForRecycleFee',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'insPaymentCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'InsurancePaymentForSettlement',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'orderType',
        internalType: 'enum OrderDescEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'immediateOrCancel',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'InvalidAccountFrozenOrder',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'depositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'posPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liqLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'premiumPnlCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
    ],
    name: 'InvalidBankruptcyPrice',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'expiryBlock',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'blockNumber',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'InvalidExpiryBlock',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'perpFeedId',
        internalType: 'bytes32',
        type: 'bytes32',
        indexed: false,
      },
      {
        name: 'reportFeedId',
        internalType: 'bytes32',
        type: 'bytes32',
        indexed: false,
      },
    ],
    name: 'InvalidLinkReportForContract',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'reportVersion',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'InvalidLinkReportVersion',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'depositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'posPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liqLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'premiumPnlCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
    ],
    name: 'InvalidLiquidationPrice',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'min', internalType: 'uint256', type: 'uint256', indexed: false },
      { name: 'max', internalType: 'uint256', type: 'uint256', indexed: false },
    ],
    name: 'InvalidOrderId',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newDescId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'LastForwardedDescIdReset',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newDescId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'LastTriggeredDescIdReset',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'verifierProxy',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
    ],
    name: 'LinkDatastreamConfigured',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'reason',
        internalType: 'string',
        type: 'string',
        indexed: false,
      },
    ],
    name: 'LinkDsError',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lowLevelData',
        internalType: 'bytes',
        type: 'bytes',
        indexed: false,
      },
    ],
    name: 'LinkDsError',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'errorCode',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'LinkDsPanic',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'oraclePricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'timestamp',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'LinkPriceUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'liquidationBuyer',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'added', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'LiquidationBuyerUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'insAmtPer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liqAmtPer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'userAmtPer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'LiquidationParamsUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'minLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'maxLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'LotOutOfRange',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'maintMarginFracHdths',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'MaintenanceMarginFractionUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'makerFeePer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'MakerFeeUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'pricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'feeCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lockedBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'balanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'MakerOrderFilled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderType',
        internalType: 'enum OrderEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'pricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'maxNegPnlCollatBPS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'reason',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lockedBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recyclerAccountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recyclerAmountCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'recyclerBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'MakerOrderSettlementFailed',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'tolerance',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'decimals',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'MarginTolUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'markPNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'spotOraclePricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'tolerancePer100k',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'MarkExceedsTol',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'markTimestamp',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'timestamp',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'maxAgeSec',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'MarkPriceAgeExceedsMax',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'pricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'MarkUpdated',
  },
  { type: 'event', anonymous: false, inputs: [], name: 'MaxMatchesReached' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'maxOpenInterestLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'MaxOpenInterestUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'MaximumAccountOrders',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'minAccountOpenCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'MinAccountOpenAmountUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'minPostCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'MinPostUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'minSettleCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'MinSettleUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'monitorAdministrator',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      { name: 'added', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'MonitorAdministratorUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'actualStatus',
        internalType: 'enum PerpStatusEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'transitioned',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'MonitorPauseAttempted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'oracleTimestamp',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'timestamp',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'maxAgeSec',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'OracleAgeExceedsMax',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'OracleDisabled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'gasLeft',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'OrderBatchCompleted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'lockedBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'balanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'OrderCancelled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lockedBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'OrderCancelledByAdmin',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lockedBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'OrderCancelledByLiquidator',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'pricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'expiryBlock',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lockedBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'OrderChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'lastOrderDescId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'OrderDescIdTooLow',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'OrderDoesNotExist',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [],
    name: 'OrderForwardingNotAllowed',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'allowed', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'OrderForwardingUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lockedBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'balanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'OrderPlaced',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'reason',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'OrderPostFailed',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderDescId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderType',
        internalType: 'enum OrderDescEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'pricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'expiryBlock',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      { name: 'postOnly', internalType: 'bool', type: 'bool', indexed: false },
      {
        name: 'fillOrKill',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
      {
        name: 'immediateOrCancel',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
      {
        name: 'maxMatches',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'leverageHdths',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lastExecutionBlock',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'maxNegPnlCollatBPS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'gasLeft',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'OrderRequest',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderType',
        internalType: 'enum OrderEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'pricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'perpPositionBalCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'perpInsuranceBalCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'addedPosCollatReqCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'requestedAmountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'OrderSettlementImpliesInsolvent',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'orderLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'availableLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'OrderSizeExceedsAvailableSize',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'threshHdths',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'OverCollatDescentThreshUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferStarted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'previousOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
      {
        name: 'newOwner',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'OwnershipTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'cancelMinOrders',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'cancelSegment',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PermissonedCancelParamsUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'realizedPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'userProceedsToPosition',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
      {
        name: 'buyToLiquidate',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
      {
        name: 'creditPerpBalCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
    ],
    name: 'PerpPositionBalCreditPositiveSevere',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'positionAdministrator',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      { name: 'added', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'PositionAdministratorUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'pricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'deltaPnlCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'fundingCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
    ],
    name: 'PositionClosed',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'markPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'impactAdjPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'startDepositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endDepositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'startEntryPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endEntryPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'effBmfHdths',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'decreaseCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PositionCollateralDecreased',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'startDepositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endDepositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'startLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'deltaPnlCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'fundingCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
    ],
    name: 'PositionDecreased',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'forceClose',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'entryPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'markPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'deleveragePricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'deltaPnlCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'fundingCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'startDepositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endDepositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'startLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PositionDeleveraged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'forceClose',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'entryPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'markPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'deleveragePricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'deltaPnlCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'fundingCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'startDepositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endDepositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'startLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'priceResiduePNSQ16',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PositionDeleveragedV2',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PositionDoesNotExist',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'leverageHdths',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'startDepositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endDepositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'pnlCollateralizedCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'premiumPnlSettledCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'maxNegPnlCollatBPS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'pricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'startLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'insFeeCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'protFeeCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PositionIncreased',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'leverageHdths',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'startDepositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endDepositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'pnlCollateralizedCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'premiumPnlSettledCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'maxNegPnlCollatBPS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'pricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'startLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'insFeeCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'protFeeCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'priceResiduePNSQ16',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PositionIncreasedV2',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'leverageHdths',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'startDepositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endDepositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'pnlCollateralizedCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'pricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'startLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'deltaPnlCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'fundingCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'insFeeCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'protFeeCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PositionInverted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'posAccountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'markPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liqPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'liqLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'posLotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'deltaPnlCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'fundingCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'posAmountCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'posDepositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accAmountCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'accBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'onOrderBook',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'PositionLiquidated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'startDepositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'endDepositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PositionLiquidationCredit',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'leverageHdths',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'depositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'pnlCollateralizedCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'pricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'insFeeCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'protFeeCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PositionOpened',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'leverageHdths',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'depositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'pnlCollateralizedCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'pricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'insFeeCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'protFeeCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'priceResiduePNSQ16',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PositionOpenedV2',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'markPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'pricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'depositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionFmvCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'paymentCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PositionUnwound',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'markPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'pricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'depositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionFmvCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'paymentCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'priceResiduePNSQ16',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PositionUnwoundV2',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'markPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'pricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'depositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionFmvCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'amountOwedCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PositionUnwoundWithoutPayment',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'markPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'pricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'depositCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionFmvCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'amountOwedCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'priceResiduePNSQ16',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PositionUnwoundWithoutPaymentV2',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'orderAmountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'minAmountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PostOrderUnderMinimum',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'priceAdministrator',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      { name: 'added', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'PriceAdministratorUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'maxAgeSec',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PriceMaxAgeUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'minPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'maxPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PriceOutOfRange',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'triggerPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PriceSetDuringTriggerExec',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'tolPer100k',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'PriceTolUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'amountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ProtocolBalanceDeposit',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'amountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ProtocolBalanceWithdraw',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recycleFeeCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recycleBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'RecycleBalanceInsufficientSevere',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recycleFeeCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recycleBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'RecycleFeeToAccount',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recycleFeeCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'recycleBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'RecycleFeeToProtocol',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'recycleFeeCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'RecycleFeeUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lastUpdateTimestamp',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'reportValidFromTimestamp',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ReportAgeExceedsLastUpdate',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'expiresAt',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'minRequired',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ReportExpiresTooSoon',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'reportTimestamp',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'blockTimestamp',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ReportFromFuture',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'reportPrice',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
    ],
    name: 'ReportPriceIsNegative',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'requestedAmountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ResidueBalanceInsufficient',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'residueAmountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ResidueTransferred',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'takerFeePer100K',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'TakerFeeUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'entryPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'collatPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'pnlPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'lotLNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'feeCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountCNS',
        internalType: 'int256',
        type: 'int256',
        indexed: false,
      },
      {
        name: 'balanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'TakerOrderFilled',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'toleranceAdministrator',
        internalType: 'address',
        type: 'address',
        indexed: false,
      },
      { name: 'added', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'ToleranceAdministratorUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'TransferAccountToProtocol',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'TransferPerpInsToProtocol',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'TransferPerpPosToProtocol',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'balanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'TransferProtocolToAccount',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'amountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'toInsuranceFund',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'TransferProtocolToPerp',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'amountCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'TransferProtocolToRecycleBal',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'lastTriggerDescId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'TriggerDescIdTooLow',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [],
    name: 'TriggerOrderExecution',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'triggerPricePNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'triggerPriceCondition',
        internalType: 'enum TriggerPriceConditionEnum',
        type: 'uint8',
        indexed: false,
      },
      {
        name: 'triggerRequestId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'triggerPositionId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'TriggerOrderRequest',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'UnableToCancelOrder',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'threshHdths',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'UnityDescentThreshUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [],
    name: 'UnspecifiedCollateral',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionsUnwound',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'perpPositionBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'insuranceBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'UnwindCompleted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'UnwindContractTrigger',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'UnwindInitializationCleared',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'sumPositiveFmvCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'UnwindInitialized',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'perpPositionBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'paymentCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'UnwindInsufficientBalance',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'positionsUnwound',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'perpPositionBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'insuranceBalanceCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'UnwindIterationCompleted',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'UnwindPreparationCleared',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'UnwindPrepared',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'UnwindProcessInProgress',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'UpdateOracleFailed',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'implementation',
        internalType: 'address',
        type: 'address',
        indexed: true,
      },
    ],
    name: 'Upgraded',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'value',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'maximum',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'ValueExceedsMaximum',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'limitCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'WRLSMinWithdrawLimitUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'thousandthsTvl',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'WRLSThousandthsTvlUpdated',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'addr', internalType: 'address', type: 'address', indexed: true },
      {
        name: 'whitelisted',
        internalType: 'bool',
        type: 'bool',
        indexed: false,
      },
    ],
    name: 'WhitelistAddress',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'enabled', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'WhitelistingEnabledChanged',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'addr', internalType: 'address', type: 'address', indexed: true },
      { name: 'enabled', internalType: 'bool', type: 'bool', indexed: false },
    ],
    name: 'WithdrawRateLimitBypassSet',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newExpiryBlock',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newLimitCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'perBlockCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'WithdrawRateLimitForceReset',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'newExpiryBlock',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'newLimitCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'perBlockCNS',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'WithdrawRateLimitReset',
  },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      {
        name: 'perpId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'orderId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
      {
        name: 'accountId',
        internalType: 'uint256',
        type: 'uint256',
        indexed: false,
      },
    ],
    name: 'WrongAccountForOrder',
  },
  {
    type: 'function',
    inputs: [],
    name: 'acceptOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'name', internalType: 'string', type: 'string' },
      { name: 'symbol', internalType: 'string', type: 'string' },
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'basePricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'priceDecimals', internalType: 'uint256', type: 'uint256' },
      { name: 'lotDecimals', internalType: 'uint256', type: 'uint256' },
      { name: 'takerFeePer100K', internalType: 'uint256', type: 'uint256' },
      { name: 'makerFeePer100K', internalType: 'uint256', type: 'uint256' },
      { name: 'initMarginFracHdths', internalType: 'uint256', type: 'uint256' },
      {
        name: 'maintMarginFracHdths',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    name: 'addContract',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'addressBlocked',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'signatures',
        internalType: 'struct OrderSignature[]',
        type: 'tuple[]',
        components: [
          { name: 'perpId', internalType: 'uint256', type: 'uint256' },
          { name: 'orderId', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    name: 'adminCancelOrders',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'allow', internalType: 'bool', type: 'bool' }],
    name: 'allowOrderForwarding',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'adlDescs',
        internalType: 'struct AdlDesc[]',
        type: 'tuple[]',
        components: [
          { name: 'perpId', internalType: 'uint256', type: 'uint256' },
          { name: 'posAccountId', internalType: 'uint256', type: 'uint256' },
          {
            name: 'sortedPositionIds',
            internalType: 'uint256[]',
            type: 'uint256[]',
          },
        ],
      },
      { name: 'revertOnFail', internalType: 'bool', type: 'bool' },
    ],
    name: 'autoDeleverage',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'liquidationDescs',
        internalType: 'struct BuyToLiquidateDesc[]',
        type: 'tuple[]',
        components: [
          { name: 'perpId', internalType: 'uint256', type: 'uint256' },
          { name: 'posAccountId', internalType: 'uint256', type: 'uint256' },
          { name: 'lotLNS', internalType: 'uint256', type: 'uint256' },
          { name: 'leverageHdths', internalType: 'uint256', type: 'uint256' },
          { name: 'limitPricePNS', internalType: 'uint256', type: 'uint256' },
          {
            name: 'maxNegPnlCollatBPS',
            internalType: 'uint256',
            type: 'uint256',
          },
        ],
      },
      { name: 'revertOnFail', internalType: 'bool', type: 'bool' },
    ],
    name: 'buyLiquidations',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'cancelDecreaseCollateralRequest',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'clearInitUnwindContract',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'orderIds', internalType: 'uint256[]', type: 'uint256[]' },
    ],
    name: 'clearOrderSlots',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'clearPrepareUnwindContract',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'pricesONS', internalType: 'uint256[]', type: 'uint256[]' },
    ],
    name: 'clearPricePointerSlots',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'amountCNS', internalType: 'uint256', type: 'uint256' }],
    name: 'createAccount',
    outputs: [{ name: 'accountId', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'reason', internalType: 'string', type: 'string' },
    ],
    name: 'declineDecreaseCollateralRequest',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'impactAdjPricePNS', internalType: 'uint32', type: 'uint32' },
      { name: 'borrowMarginFracHdths', internalType: 'uint16', type: 'uint16' },
      {
        name: 'positionType',
        internalType: 'enum PositionEnum',
        type: 'uint8',
      },
    ],
    name: 'decreasePositionCollateral',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'amountCNS', internalType: 'uint256', type: 'uint256' }],
    name: 'depositCollateral',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'amountCNS', internalType: 'uint256', type: 'uint256' }],
    name: 'depositToProtocol',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'forwardedOrders',
        internalType: 'struct FwdOrderDesc[]',
        type: 'tuple[]',
        components: [
          { name: 'accountId', internalType: 'uint256', type: 'uint256' },
          { name: 'feePer100K', internalType: 'uint256', type: 'uint256' },
          {
            name: 'orderDesc',
            internalType: 'struct OrderDesc',
            type: 'tuple',
            components: [
              { name: 'orderDescId', internalType: 'uint256', type: 'uint256' },
              { name: 'perpId', internalType: 'uint256', type: 'uint256' },
              {
                name: 'orderType',
                internalType: 'enum OrderDescEnum',
                type: 'uint8',
              },
              { name: 'orderId', internalType: 'uint256', type: 'uint256' },
              { name: 'pricePNS', internalType: 'uint256', type: 'uint256' },
              { name: 'lotLNS', internalType: 'uint256', type: 'uint256' },
              { name: 'expiryBlock', internalType: 'uint256', type: 'uint256' },
              { name: 'postOnly', internalType: 'bool', type: 'bool' },
              { name: 'fillOrKill', internalType: 'bool', type: 'bool' },
              { name: 'immediateOrCancel', internalType: 'bool', type: 'bool' },
              { name: 'maxMatches', internalType: 'uint256', type: 'uint256' },
              {
                name: 'leverageHdths',
                internalType: 'uint256',
                type: 'uint256',
              },
              {
                name: 'lastExecutionBlock',
                internalType: 'uint256',
                type: 'uint256',
              },
              { name: 'amountCNS', internalType: 'uint256', type: 'uint256' },
              {
                name: 'maxNegPnlCollatBPS',
                internalType: 'uint256',
                type: 'uint256',
              },
            ],
          },
          { name: 'execTriggerOrder', internalType: 'bool', type: 'bool' },
          { name: 'triggerPricePNS', internalType: 'uint256', type: 'uint256' },
          {
            name: 'triggerPriceCondition',
            internalType: 'enum TriggerPriceConditionEnum',
            type: 'uint8',
          },
          {
            name: 'triggerRequestId',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'triggerPositionId',
            internalType: 'uint256',
            type: 'uint256',
          },
        ],
      },
    ],
    name: 'execFwdPositionOps',
    outputs: [
      {
        name: 'signatures',
        internalType: 'struct OrderSignature[]',
        type: 'tuple[]',
        components: [
          { name: 'perpId', internalType: 'uint256', type: 'uint256' },
          { name: 'orderId', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'fznAccountCloseOrders',
        internalType: 'struct FznOrderDesc[]',
        type: 'tuple[]',
        components: [
          { name: 'accountId', internalType: 'uint256', type: 'uint256' },
          {
            name: 'orderDesc',
            internalType: 'struct OrderDesc',
            type: 'tuple',
            components: [
              { name: 'orderDescId', internalType: 'uint256', type: 'uint256' },
              { name: 'perpId', internalType: 'uint256', type: 'uint256' },
              {
                name: 'orderType',
                internalType: 'enum OrderDescEnum',
                type: 'uint8',
              },
              { name: 'orderId', internalType: 'uint256', type: 'uint256' },
              { name: 'pricePNS', internalType: 'uint256', type: 'uint256' },
              { name: 'lotLNS', internalType: 'uint256', type: 'uint256' },
              { name: 'expiryBlock', internalType: 'uint256', type: 'uint256' },
              { name: 'postOnly', internalType: 'bool', type: 'bool' },
              { name: 'fillOrKill', internalType: 'bool', type: 'bool' },
              { name: 'immediateOrCancel', internalType: 'bool', type: 'bool' },
              { name: 'maxMatches', internalType: 'uint256', type: 'uint256' },
              {
                name: 'leverageHdths',
                internalType: 'uint256',
                type: 'uint256',
              },
              {
                name: 'lastExecutionBlock',
                internalType: 'uint256',
                type: 'uint256',
              },
              { name: 'amountCNS', internalType: 'uint256', type: 'uint256' },
              {
                name: 'maxNegPnlCollatBPS',
                internalType: 'uint256',
                type: 'uint256',
              },
            ],
          },
        ],
      },
    ],
    name: 'execFznAccountPosOps',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'orderDesc',
        internalType: 'struct OrderDesc',
        type: 'tuple',
        components: [
          { name: 'orderDescId', internalType: 'uint256', type: 'uint256' },
          { name: 'perpId', internalType: 'uint256', type: 'uint256' },
          {
            name: 'orderType',
            internalType: 'enum OrderDescEnum',
            type: 'uint8',
          },
          { name: 'orderId', internalType: 'uint256', type: 'uint256' },
          { name: 'pricePNS', internalType: 'uint256', type: 'uint256' },
          { name: 'lotLNS', internalType: 'uint256', type: 'uint256' },
          { name: 'expiryBlock', internalType: 'uint256', type: 'uint256' },
          { name: 'postOnly', internalType: 'bool', type: 'bool' },
          { name: 'fillOrKill', internalType: 'bool', type: 'bool' },
          { name: 'immediateOrCancel', internalType: 'bool', type: 'bool' },
          { name: 'maxMatches', internalType: 'uint256', type: 'uint256' },
          { name: 'leverageHdths', internalType: 'uint256', type: 'uint256' },
          {
            name: 'lastExecutionBlock',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'amountCNS', internalType: 'uint256', type: 'uint256' },
          {
            name: 'maxNegPnlCollatBPS',
            internalType: 'uint256',
            type: 'uint256',
          },
        ],
      },
    ],
    name: 'execOrder',
    outputs: [
      {
        name: 'signature',
        internalType: 'struct OrderSignature',
        type: 'tuple',
        components: [
          { name: 'perpId', internalType: 'uint256', type: 'uint256' },
          { name: 'orderId', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'orderDescs',
        internalType: 'struct OrderDesc[]',
        type: 'tuple[]',
        components: [
          { name: 'orderDescId', internalType: 'uint256', type: 'uint256' },
          { name: 'perpId', internalType: 'uint256', type: 'uint256' },
          {
            name: 'orderType',
            internalType: 'enum OrderDescEnum',
            type: 'uint8',
          },
          { name: 'orderId', internalType: 'uint256', type: 'uint256' },
          { name: 'pricePNS', internalType: 'uint256', type: 'uint256' },
          { name: 'lotLNS', internalType: 'uint256', type: 'uint256' },
          { name: 'expiryBlock', internalType: 'uint256', type: 'uint256' },
          { name: 'postOnly', internalType: 'bool', type: 'bool' },
          { name: 'fillOrKill', internalType: 'bool', type: 'bool' },
          { name: 'immediateOrCancel', internalType: 'bool', type: 'bool' },
          { name: 'maxMatches', internalType: 'uint256', type: 'uint256' },
          { name: 'leverageHdths', internalType: 'uint256', type: 'uint256' },
          {
            name: 'lastExecutionBlock',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'amountCNS', internalType: 'uint256', type: 'uint256' },
          {
            name: 'maxNegPnlCollatBPS',
            internalType: 'uint256',
            type: 'uint256',
          },
        ],
      },
      { name: 'revertOnFail', internalType: 'bool', type: 'bool' },
    ],
    name: 'execOrders',
    outputs: [
      {
        name: 'signatures',
        internalType: 'struct OrderSignature[]',
        type: 'tuple[]',
        components: [
          { name: 'perpId', internalType: 'uint256', type: 'uint256' },
          { name: 'orderId', internalType: 'uint256', type: 'uint256' },
        ],
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'operations',
        internalType: 'struct OpDesc[]',
        type: 'tuple[]',
        components: [
          { name: 'opDescId', internalType: 'uint256', type: 'uint256' },
          { name: 'perpId', internalType: 'uint256', type: 'uint256' },
          { name: 'opType', internalType: 'enum OpDescEnum', type: 'uint8' },
          { name: 'pricePNS', internalType: 'uint32', type: 'uint32' },
          {
            name: 'fundingRatePct100k',
            internalType: 'int256',
            type: 'int256',
          },
          { name: 'allowOverwrite', internalType: 'bool', type: 'bool' },
          { name: 'unverifiedReport', internalType: 'bytes', type: 'bytes' },
        ],
      },
    ],
    name: 'execPerpOps',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'posAccountId', internalType: 'uint256', type: 'uint256' },
      {
        name: 'sortedPositionIds',
        internalType: 'uint256[]',
        type: 'uint256[]',
      },
      { name: 'revertOnFail', internalType: 'bool', type: 'bool' },
    ],
    name: 'forceClose',
    outputs: [{ name: 'success', internalType: 'bool', type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'forceResetWithdrawRateLimit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'accountAddress', internalType: 'address', type: 'address' },
    ],
    name: 'getAccountByAddr',
    outputs: [
      {
        name: 'accountInfo',
        internalType: 'struct AccountInfo',
        type: 'tuple',
        components: [
          { name: 'accountId', internalType: 'uint256', type: 'uint256' },
          { name: 'balanceCNS', internalType: 'uint256', type: 'uint256' },
          {
            name: 'lockedBalanceCNS',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'frozen',
            internalType: 'enum FreezeStatusEnum',
            type: 'uint8',
          },
          { name: 'accountAddr', internalType: 'address', type: 'address' },
          {
            name: 'positions',
            internalType: 'struct PositionBitMap',
            type: 'tuple',
            components: [
              { name: 'bank1', internalType: 'uint256', type: 'uint256' },
              { name: 'bank2', internalType: 'uint256', type: 'uint256' },
              { name: 'bank3', internalType: 'uint256', type: 'uint256' },
              { name: 'bank4', internalType: 'uint256', type: 'uint256' },
            ],
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'accountId', internalType: 'uint256', type: 'uint256' }],
    name: 'getAccountById',
    outputs: [
      {
        name: 'accountInfo',
        internalType: 'struct AccountInfo',
        type: 'tuple',
        components: [
          { name: 'accountId', internalType: 'uint256', type: 'uint256' },
          { name: 'balanceCNS', internalType: 'uint256', type: 'uint256' },
          {
            name: 'lockedBalanceCNS',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'frozen',
            internalType: 'enum FreezeStatusEnum',
            type: 'uint8',
          },
          { name: 'accountAddr', internalType: 'address', type: 'address' },
          {
            name: 'positions',
            internalType: 'struct PositionBitMap',
            type: 'tuple',
            components: [
              { name: 'bank1', internalType: 'uint256', type: 'uint256' },
              { name: 'bank2', internalType: 'uint256', type: 'uint256' },
              { name: 'bank3', internalType: 'uint256', type: 'uint256' },
              { name: 'bank4', internalType: 'uint256', type: 'uint256' },
            ],
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getExchangeInfo',
    outputs: [
      { name: 'balanceCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'protocolBalanceCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'recycleBalanceCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'collateralDecimals', internalType: 'uint256', type: 'uint256' },
      { name: 'collateralToken', internalType: 'address', type: 'address' },
      { name: 'verifierProxy', internalType: 'address', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getFundingInterval',
    outputs: [
      { name: 'fundingInterval', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'pure',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'blockNumber', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getFundingSumAtBlock',
    outputs: [
      { name: 'fundingSumPNS', internalType: 'int48', type: 'int48' },
      { name: 'fundingEventBlock', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'getLiquidationInfo',
    outputs: [
      {
        name: 'liquidationInfo',
        internalType: 'struct LiquidationInfo',
        type: 'tuple',
        components: [
          {
            name: 'liqInsAmtPer100K',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'liqUserAmtPer100K',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'liqProtocolAmtPer100K',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'btlPriceThreshPer100K',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'btlInsAmtPer100K',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'btlUserAmtPer100K',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'btlBuyerAmtPer100K',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'btlProtocolAmtPer100K',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'btlRestrictBuyers', internalType: 'bool', type: 'bool' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'getMakerFee',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'lotLNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getMarginFractions',
    outputs: [
      {
        name: 'perpInitMarginFracHdths',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'perpMaintMarginFracHdths',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'dynamicInitMarginFracHdths',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'oiMaxLNS', internalType: 'uint256', type: 'uint256' },
      {
        name: 'unityDescentThreshHdths',
        internalType: 'uint256',
        type: 'uint256',
      },
      {
        name: 'overColDescentThreshHdths',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getMinAccountOpenCNS',
    outputs: [
      { name: 'minAccountOpenCNS', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getMinimumPostCNS',
    outputs: [
      { name: 'minimumPostCNS', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getMinimumSettleCNS',
    outputs: [
      { name: 'minimumSettleCNS', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'priceONS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getNextPriceAboveWithOrders',
    outputs: [
      { name: 'priceAboveONS', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'priceONS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getNextPriceBelowWithOrders',
    outputs: [
      { name: 'priceBelowONS', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'orderId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getOrder',
    outputs: [
      {
        name: 'order',
        internalType: 'struct Order',
        type: 'tuple',
        components: [
          { name: 'accountId', internalType: 'uint32', type: 'uint32' },
          { name: 'orderType', internalType: 'enum OrderEnum', type: 'uint8' },
          { name: 'priceONS', internalType: 'uint24', type: 'uint24' },
          { name: 'lotLNS', internalType: 'uint40', type: 'uint40' },
          { name: 'recycleFeeRaw', internalType: 'uint16', type: 'uint16' },
          { name: 'expiryBlock', internalType: 'uint32', type: 'uint32' },
          { name: 'leverageHdths', internalType: 'uint16', type: 'uint16' },
          { name: 'orderId', internalType: 'uint16', type: 'uint16' },
          { name: 'prevOrderId', internalType: 'uint16', type: 'uint16' },
          { name: 'nextOrderId', internalType: 'uint16', type: 'uint16' },
          {
            name: 'maxNegPnlCollatBPS',
            internalType: 'uint16',
            type: 'uint16',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'getOrderIdIndex',
    outputs: [
      { name: 'root', internalType: 'uint256', type: 'uint256' },
      { name: 'leaves', internalType: 'uint256[]', type: 'uint256[]' },
      { name: 'numOrders', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'accountId', internalType: 'uint256', type: 'uint256' }],
    name: 'getOrderLocks',
    outputs: [
      {
        name: 'orderLocks',
        internalType: 'struct OrderLock[]',
        type: 'tuple[]',
        components: [
          { name: 'orderLockId', internalType: 'uint32', type: 'uint32' },
          { name: 'nextOrderLockId', internalType: 'uint32', type: 'uint32' },
          { name: 'prevOrderLockId', internalType: 'uint32', type: 'uint32' },
          { name: 'orderType', internalType: 'enum OrderEnum', type: 'uint8' },
          { name: 'lotLNS', internalType: 'uint40', type: 'uint40' },
          { name: 'amountCNS', internalType: 'uint80', type: 'uint80' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'priceONS', internalType: 'uint256', type: 'uint256' },
      { name: 'pageStartOrderId', internalType: 'uint256', type: 'uint256' },
      { name: 'ordersPerPage', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getOrdersAtPriceLevel',
    outputs: [
      {
        name: 'ordersAtPriceLevel',
        internalType: 'struct Order[]',
        type: 'tuple[]',
        components: [
          { name: 'accountId', internalType: 'uint32', type: 'uint32' },
          { name: 'orderType', internalType: 'enum OrderEnum', type: 'uint8' },
          { name: 'priceONS', internalType: 'uint24', type: 'uint24' },
          { name: 'lotLNS', internalType: 'uint40', type: 'uint40' },
          { name: 'recycleFeeRaw', internalType: 'uint16', type: 'uint16' },
          { name: 'expiryBlock', internalType: 'uint32', type: 'uint32' },
          { name: 'leverageHdths', internalType: 'uint16', type: 'uint16' },
          { name: 'orderId', internalType: 'uint16', type: 'uint16' },
          { name: 'prevOrderId', internalType: 'uint16', type: 'uint16' },
          { name: 'nextOrderId', internalType: 'uint16', type: 'uint16' },
          {
            name: 'maxNegPnlCollatBPS',
            internalType: 'uint16',
            type: 'uint16',
          },
        ],
      },
      { name: 'numOrders', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getOwner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'getPermissionedCancelParams',
    outputs: [
      { name: 'permCancelMinOrders', internalType: 'uint256', type: 'uint256' },
      { name: 'permCancelSegment', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getPerpOrderLocks',
    outputs: [
      {
        name: 'perpOrderLocks',
        internalType: 'struct OrderLock[]',
        type: 'tuple[]',
        components: [
          { name: 'orderLockId', internalType: 'uint32', type: 'uint32' },
          { name: 'nextOrderLockId', internalType: 'uint32', type: 'uint32' },
          { name: 'prevOrderLockId', internalType: 'uint32', type: 'uint32' },
          { name: 'orderType', internalType: 'enum OrderEnum', type: 'uint8' },
          { name: 'lotLNS', internalType: 'uint40', type: 'uint40' },
          { name: 'amountCNS', internalType: 'uint80', type: 'uint80' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'getPerpetualInfo',
    outputs: [
      {
        name: 'perpetualInfo',
        internalType: 'struct PerpetualInfo',
        type: 'tuple',
        components: [
          { name: 'name', internalType: 'string', type: 'string' },
          { name: 'symbol', internalType: 'string', type: 'string' },
          { name: 'priceDecimals', internalType: 'uint256', type: 'uint256' },
          { name: 'lotDecimals', internalType: 'uint256', type: 'uint256' },
          { name: 'linkFeedId', internalType: 'bytes32', type: 'bytes32' },
          { name: 'priceTolPer100K', internalType: 'uint256', type: 'uint256' },
          { name: 'marginTol', internalType: 'uint256', type: 'uint256' },
          {
            name: 'marginTolDecimals',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'refPriceMaxAgeSec',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'positionBalanceCNS',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'insuranceBalanceCNS',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'markPNS', internalType: 'uint256', type: 'uint256' },
          { name: 'markTimestamp', internalType: 'uint256', type: 'uint256' },
          { name: 'lastPNS', internalType: 'uint256', type: 'uint256' },
          { name: 'lastTimestamp', internalType: 'uint256', type: 'uint256' },
          { name: 'oraclePNS', internalType: 'uint256', type: 'uint256' },
          {
            name: 'oracleTimestampSec',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'longOpenInterestLNS',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'shortOpenInterestLNS',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'fundingStartBlock',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'fundingRatePct100k', internalType: 'int16', type: 'int16' },
          {
            name: 'absFundingClampPctPer100K',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'status',
            internalType: 'enum PerpStatusEnum',
            type: 'uint8',
          },
          { name: 'basePricePNS', internalType: 'uint256', type: 'uint256' },
          { name: 'maxBidPriceONS', internalType: 'uint256', type: 'uint256' },
          { name: 'minBidPriceONS', internalType: 'uint256', type: 'uint256' },
          { name: 'maxAskPriceONS', internalType: 'uint256', type: 'uint256' },
          { name: 'minAskPriceONS', internalType: 'uint256', type: 'uint256' },
          { name: 'numOrders', internalType: 'uint256', type: 'uint256' },
          { name: 'ignOracle', internalType: 'bool', type: 'bool' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'getPerpetualInfoV2',
    outputs: [
      {
        name: 'perpetualInfo',
        internalType: 'struct PerpetualInfoV2',
        type: 'tuple',
        components: [
          { name: 'name', internalType: 'string', type: 'string' },
          { name: 'symbol', internalType: 'string', type: 'string' },
          { name: 'priceDecimals', internalType: 'uint256', type: 'uint256' },
          { name: 'lotDecimals', internalType: 'uint256', type: 'uint256' },
          { name: 'linkFeedId', internalType: 'bytes32', type: 'bytes32' },
          { name: 'priceTolPer100K', internalType: 'uint256', type: 'uint256' },
          { name: 'marginTol', internalType: 'uint256', type: 'uint256' },
          {
            name: 'marginTolDecimals',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'refPriceMaxAgeSec',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'positionBalanceCNS',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'insuranceBalanceCNS',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'markPNS', internalType: 'uint256', type: 'uint256' },
          { name: 'markTimestamp', internalType: 'uint256', type: 'uint256' },
          { name: 'lastPNS', internalType: 'uint256', type: 'uint256' },
          { name: 'lastTimestamp', internalType: 'uint256', type: 'uint256' },
          { name: 'oraclePNS', internalType: 'uint256', type: 'uint256' },
          {
            name: 'oracleTimestampSec',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'longOpenInterestLNS',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'shortOpenInterestLNS',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'fundingStartBlock',
            internalType: 'uint256',
            type: 'uint256',
          },
          { name: 'fundingRatePct100k', internalType: 'int16', type: 'int16' },
          {
            name: 'absFundingClampPctPer100K',
            internalType: 'uint256',
            type: 'uint256',
          },
          {
            name: 'status',
            internalType: 'enum PerpStatusEnum',
            type: 'uint8',
          },
          { name: 'basePricePNS', internalType: 'uint256', type: 'uint256' },
          { name: 'maxBidPriceONS', internalType: 'uint256', type: 'uint256' },
          { name: 'minBidPriceONS', internalType: 'uint256', type: 'uint256' },
          { name: 'maxAskPriceONS', internalType: 'uint256', type: 'uint256' },
          { name: 'minAskPriceONS', internalType: 'uint256', type: 'uint256' },
          { name: 'numOrders', internalType: 'uint256', type: 'uint256' },
          { name: 'ignOracle', internalType: 'bool', type: 'bool' },
          {
            name: 'fundingSumScalingExp',
            internalType: 'uint256',
            type: 'uint256',
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getPosition',
    outputs: [
      {
        name: 'positionInfo',
        internalType: 'struct PositionInfo',
        type: 'tuple',
        components: [
          { name: 'accountId', internalType: 'uint256', type: 'uint256' },
          { name: 'nextNodeId', internalType: 'uint256', type: 'uint256' },
          { name: 'prevNodeId', internalType: 'uint256', type: 'uint256' },
          {
            name: 'positionType',
            internalType: 'enum PositionEnum',
            type: 'uint8',
          },
          { name: 'depositCNS', internalType: 'uint256', type: 'uint256' },
          { name: 'pricePNS', internalType: 'uint256', type: 'uint256' },
          { name: 'lotLNS', internalType: 'uint256', type: 'uint256' },
          { name: 'entryBlock', internalType: 'uint256', type: 'uint256' },
          { name: 'pnlCNS', internalType: 'int256', type: 'int256' },
          { name: 'deltaPnlCNS', internalType: 'int256', type: 'int256' },
          { name: 'premiumPnlCNS', internalType: 'int256', type: 'int256' },
        ],
      },
      { name: 'markPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'markPriceValid', internalType: 'bool', type: 'bool' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'getPositionIds',
    outputs: [
      { name: 'startNodeId', internalType: 'uint256', type: 'uint256' },
      { name: 'endNodeId', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getPositionV2',
    outputs: [
      {
        name: 'positionInfo',
        internalType: 'struct PositionInfoV2',
        type: 'tuple',
        components: [
          { name: 'accountId', internalType: 'uint256', type: 'uint256' },
          { name: 'nextNodeId', internalType: 'uint256', type: 'uint256' },
          { name: 'prevNodeId', internalType: 'uint256', type: 'uint256' },
          {
            name: 'positionType',
            internalType: 'enum PositionEnum',
            type: 'uint8',
          },
          { name: 'depositCNS', internalType: 'uint256', type: 'uint256' },
          { name: 'pricePNS', internalType: 'uint256', type: 'uint256' },
          { name: 'lotLNS', internalType: 'uint256', type: 'uint256' },
          { name: 'entryBlock', internalType: 'uint256', type: 'uint256' },
          { name: 'pnlCNS', internalType: 'int256', type: 'int256' },
          { name: 'deltaPnlCNS', internalType: 'int256', type: 'int256' },
          { name: 'premiumPnlCNS', internalType: 'int256', type: 'int256' },
          {
            name: 'priceResiduePNSQ16',
            internalType: 'uint256',
            type: 'uint256',
          },
        ],
      },
      { name: 'markPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'markPriceValid', internalType: 'bool', type: 'bool' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'pageStartPositionId', internalType: 'uint256', type: 'uint256' },
      { name: 'positionsPerPage', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getPositions',
    outputs: [
      {
        name: 'positions',
        internalType: 'struct PositionInfo[]',
        type: 'tuple[]',
        components: [
          { name: 'accountId', internalType: 'uint256', type: 'uint256' },
          { name: 'nextNodeId', internalType: 'uint256', type: 'uint256' },
          { name: 'prevNodeId', internalType: 'uint256', type: 'uint256' },
          {
            name: 'positionType',
            internalType: 'enum PositionEnum',
            type: 'uint8',
          },
          { name: 'depositCNS', internalType: 'uint256', type: 'uint256' },
          { name: 'pricePNS', internalType: 'uint256', type: 'uint256' },
          { name: 'lotLNS', internalType: 'uint256', type: 'uint256' },
          { name: 'entryBlock', internalType: 'uint256', type: 'uint256' },
          { name: 'pnlCNS', internalType: 'int256', type: 'int256' },
          { name: 'deltaPnlCNS', internalType: 'int256', type: 'int256' },
          { name: 'premiumPnlCNS', internalType: 'int256', type: 'int256' },
        ],
      },
      { name: 'numPositions', internalType: 'uint256', type: 'uint256' },
      { name: 'markPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'markPriceValid', internalType: 'bool', type: 'bool' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'pageStartPositionId', internalType: 'uint256', type: 'uint256' },
      { name: 'positionsPerPage', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getPositionsV2',
    outputs: [
      {
        name: 'positions',
        internalType: 'struct PositionInfoV2[]',
        type: 'tuple[]',
        components: [
          { name: 'accountId', internalType: 'uint256', type: 'uint256' },
          { name: 'nextNodeId', internalType: 'uint256', type: 'uint256' },
          { name: 'prevNodeId', internalType: 'uint256', type: 'uint256' },
          {
            name: 'positionType',
            internalType: 'enum PositionEnum',
            type: 'uint8',
          },
          { name: 'depositCNS', internalType: 'uint256', type: 'uint256' },
          { name: 'pricePNS', internalType: 'uint256', type: 'uint256' },
          { name: 'lotLNS', internalType: 'uint256', type: 'uint256' },
          { name: 'entryBlock', internalType: 'uint256', type: 'uint256' },
          { name: 'pnlCNS', internalType: 'int256', type: 'int256' },
          { name: 'deltaPnlCNS', internalType: 'int256', type: 'int256' },
          { name: 'premiumPnlCNS', internalType: 'int256', type: 'int256' },
          {
            name: 'priceResiduePNSQ16',
            internalType: 'uint256',
            type: 'uint256',
          },
        ],
      },
      { name: 'numPositions', internalType: 'uint256', type: 'uint256' },
      { name: 'markPricePNS', internalType: 'uint256', type: 'uint256' },
      { name: 'markPriceValid', internalType: 'bool', type: 'bool' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'priceONS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getPriceLevelOrderIds',
    outputs: [
      { name: 'startOrderId', internalType: 'uint256', type: 'uint256' },
      { name: 'endOrderId', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getProtocolBalanceCNS',
    outputs: [
      { name: 'protocolBalanceCNS', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getRecycleBalanceCNS',
    outputs: [
      { name: 'recycleBalanceCNS', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'getRecycleFeeCNS',
    outputs: [
      { name: 'recycleFeeCNS', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'getTakerFee',
    outputs: [{ name: '', internalType: 'uint256', type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'getUnwindInfo',
    outputs: [
      { name: 'status', internalType: 'enum PerpStatusEnum', type: 'uint8' },
      {
        name: 'unwindSumPositiveFmvCNS',
        internalType: 'uint256',
        type: 'uint256',
      },
      { name: 'unwindInitPosBalCNS', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'priceONS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'getVolumeAtBookPrice',
    outputs: [
      { name: 'bids', internalType: 'uint256', type: 'uint256' },
      { name: 'expBids', internalType: 'uint256', type: 'uint256' },
      { name: 'asks', internalType: 'uint256', type: 'uint256' },
      { name: 'expAsks', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'blockNumber', internalType: 'uint256', type: 'uint256' }],
    name: 'getWithdrawAllowanceData',
    outputs: [
      { name: 'allowanceCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'expiryBlock', internalType: 'uint256', type: 'uint256' },
      { name: 'lastAllowanceBlock', internalType: 'uint256', type: 'uint256' },
      { name: 'cnsPerBlock', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'amountCNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'increasePositionCollateral',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'sumPositiveFmvCNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'initUnwindContract',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'collateralToken', internalType: 'address', type: 'address' },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'configs',
        internalType: 'struct Exchange.PerpScalingConfig[]',
        type: 'tuple[]',
        components: [
          { name: 'perpId', internalType: 'uint256', type: 'uint256' },
          {
            name: 'fundingSumScalingExp',
            internalType: 'uint256',
            type: 'uint256',
          },
        ],
      },
      {
        name: 'residueTransfers',
        internalType: 'struct Exchange.ResidueTransfer[]',
        type: 'tuple[]',
        components: [
          { name: 'perpId', internalType: 'uint256', type: 'uint256' },
          {
            name: 'residueAmountCNS',
            internalType: 'uint256',
            type: 'uint256',
          },
        ],
      },
    ],
    name: 'initializeV2',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'anAddress', internalType: 'address', type: 'address' }],
    name: 'isAdministrator',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'isHalted',
    outputs: [{ name: 'halted', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'anAddress', internalType: 'address', type: 'address' }],
    name: 'isLiquidationBuyer',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'anAddress', internalType: 'address', type: 'address' }],
    name: 'isPositionAdministrator',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'anAddress', internalType: 'address', type: 'address' }],
    name: 'isPriceAdministrator',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'anAddress', internalType: 'address', type: 'address' }],
    name: 'isToleranceAdministrator',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'liquidationDesc',
        internalType: 'struct LiquidationDesc',
        type: 'tuple',
        components: [
          { name: 'perpId', internalType: 'uint256', type: 'uint256' },
          { name: 'posAccountId', internalType: 'uint256', type: 'uint256' },
          { name: 'lotLNS', internalType: 'uint256', type: 'uint256' },
          {
            name: 'userProceedsToPosition',
            internalType: 'bool',
            type: 'bool',
          },
        ],
      },
    ],
    name: 'liquidation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'liquidationDescs',
        internalType: 'struct LiquidationDesc[]',
        type: 'tuple[]',
        components: [
          { name: 'perpId', internalType: 'uint256', type: 'uint256' },
          { name: 'posAccountId', internalType: 'uint256', type: 'uint256' },
          { name: 'lotLNS', internalType: 'uint256', type: 'uint256' },
          {
            name: 'userProceedsToPosition',
            internalType: 'bool',
            type: 'bool',
          },
        ],
      },
      { name: 'revertOnFail', internalType: 'bool', type: 'bool' },
    ],
    name: 'liquidations',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'numberOfAccounts',
    outputs: [
      { name: 'numAccounts', internalType: 'uint256', type: 'uint256' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'owner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'pauseContract',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'pauseContractByMonitor',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'pendingOwner',
    outputs: [{ name: '', internalType: 'address', type: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'prepareUnwindContract',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'proxiableUUID',
    outputs: [{ name: '', internalType: 'bytes32', type: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'removeContract',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'amountCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'clampToMaximum', internalType: 'bool', type: 'bool' },
    ],
    name: 'requestDecreasePositionCollateral',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'addresses', internalType: 'address[]', type: 'address[]' },
      { name: 'blocked', internalType: 'bool', type: 'bool' },
    ],
    name: 'setAddressBlockStatus',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'addresses', internalType: 'address[]', type: 'address[]' },
      { name: 'whitelisted_', internalType: 'bool', type: 'bool' },
    ],
    name: 'setAddressWhitelisted',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'administrator', internalType: 'address', type: 'address' },
      { name: 'add', internalType: 'bool', type: 'bool' },
    ],
    name: 'setAdministrator',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'restrictBuyers', internalType: 'bool', type: 'bool' },
    ],
    name: 'setBuyToLiquidateBuyerRestriction',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'insAmtPer100K', internalType: 'uint256', type: 'uint256' },
      { name: 'userAmtPer100K', internalType: 'uint256', type: 'uint256' },
      { name: 'buyerAmtPer100K', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setBuyToLiquidateParams',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'thresholdPer100K', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setBuyToLiquidatePriceThreshold',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'paused', internalType: 'bool', type: 'bool' },
    ],
    name: 'setContractPaused',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'threshHdths', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setDcpBorrowThreshold',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'halted', internalType: 'bool', type: 'bool' }],
    name: 'setExchangeHalted',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'insAmtPer100K', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setFeeParams',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'account', internalType: 'address', type: 'address' },
      { name: 'status', internalType: 'enum FreezeStatusEnum', type: 'uint8' },
    ],
    name: 'setFreezeStatus',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'account', internalType: 'address', type: 'address' },
      { name: 'status', internalType: 'enum FreezeStatusEnum', type: 'uint8' },
    ],
    name: 'setFrozen',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      {
        name: 'absFundingClampPctPer100K',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    name: 'setFundingClampPct',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'fundingRatePct100k', internalType: 'int256', type: 'int256' },
      { name: 'pricePNS', internalType: 'uint32', type: 'uint32' },
      { name: 'allowOverwrite', internalType: 'bool', type: 'bool' },
      { name: 'revertOnFail', internalType: 'bool', type: 'bool' },
    ],
    name: 'setFundingSum',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      {
        name: 'fundingSumScalingExp',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    name: 'setFundingSumScalingExp',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'ignOracle', internalType: 'bool', type: 'bool' },
    ],
    name: 'setIgnOracle',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'initMarginFracHdths', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setInitialMarginFraction',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'newDescId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setLastForwardedDescId',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'newDescId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setLastForwardedDescIdAsOwner',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'newDescId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setLastTriggeredDescId',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'newDescId', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setLastTriggeredDescIdAsOwner',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'verifierProxy', internalType: 'address', type: 'address' },
    ],
    name: 'setLinkDsVerifier',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'liquidationBuyer', internalType: 'address', type: 'address' },
      { name: 'add', internalType: 'bool', type: 'bool' },
    ],
    name: 'setLiquidationBuyer',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'insAmtPer100K', internalType: 'uint256', type: 'uint256' },
      { name: 'userAmtPer100K', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setLiquidationParams',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      {
        name: 'maintMarginFracHdths',
        internalType: 'uint256',
        type: 'uint256',
      },
    ],
    name: 'setMaintenanceMarginFraction',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'makerFeePer100K', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setMakerFee',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'tolerance', internalType: 'uint256', type: 'uint256' },
      { name: 'decimals', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setMarginTol',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'maxOpenInterestLNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setMaxOpenInterest',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'amountCNS', internalType: 'uint256', type: 'uint256' }],
    name: 'setMinAccountOpenAmount',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'minPostCNS', internalType: 'uint256', type: 'uint256' }],
    name: 'setMinPost',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'minSettleCNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setMinSettle',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'limitCNS', internalType: 'uint256', type: 'uint256' }],
    name: 'setMinWithdrawLimit',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'monitorAdministrator',
        internalType: 'address',
        type: 'address',
      },
      { name: 'add', internalType: 'bool', type: 'bool' },
    ],
    name: 'setMonitorAdministrator',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'threshHdths', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setOverCollatDescentThreshold',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'permCancelMinOrders', internalType: 'uint256', type: 'uint256' },
      { name: 'permCancelSegment', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setPermissionedCancelParams',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'feedId', internalType: 'bytes32', type: 'bytes32' },
    ],
    name: 'setPerpLinkDsFeedId',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'positionAdministrator',
        internalType: 'address',
        type: 'address',
      },
      { name: 'add', internalType: 'bool', type: 'bool' },
    ],
    name: 'setPositionAdministrator',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'priceAdministrator', internalType: 'address', type: 'address' },
      { name: 'add', internalType: 'bool', type: 'bool' },
    ],
    name: 'setPriceAdministrator',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'maxAgeSec', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setPriceMaxAge',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'tolerancePer100K', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setPriceTolPer100K',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'tolerancePer100K', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setPriceTolPer100KByOwner',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'recycleFeeCNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setRecycleFee',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'takerFeePer100K', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setTakerFee',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'thousandthsTvl', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setThousandthsTvlWRLS',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      {
        name: 'toleranceAdministrator',
        internalType: 'address',
        type: 'address',
      },
      { name: 'add', internalType: 'bool', type: 'bool' },
    ],
    name: 'setToleranceAdministrator',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'threshHdths', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'setUnityDescentThreshold',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'enabled', internalType: 'bool', type: 'bool' }],
    name: 'setWhitelistingEnabled',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'addr', internalType: 'address', type: 'address' },
      { name: 'enabled', internalType: 'bool', type: 'bool' },
    ],
    name: 'setWithdrawBypass',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'newOwner', internalType: 'address', type: 'address' }],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'perpId', internalType: 'uint256', type: 'uint256' }],
    name: 'triggerUnwindContract',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'maxPosToUnwind', internalType: 'uint256', type: 'uint256' },
      { name: 'allowWithoutPayment', internalType: 'bool', type: 'bool' },
    ],
    name: 'unwindContract',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'maxPosToUnwind', internalType: 'uint256', type: 'uint256' },
      { name: 'allowWithoutPayment', internalType: 'bool', type: 'bool' },
    ],
    name: 'unwindContractByOwner',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'markPricePNS', internalType: 'uint32', type: 'uint32' },
    ],
    name: 'updateMarkPricePNS',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'markPricePNS', internalType: 'uint32', type: 'uint32' },
    ],
    name: 'updateMarkPricePNSByOwner',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'unverifiedReport', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'updateOraclePrice',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newImplementation', internalType: 'address', type: 'address' },
    ],
    name: 'upgradeTo',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'newImplementation', internalType: 'address', type: 'address' },
      { name: 'data', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'upgradeToAndCall',
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    inputs: [{ name: '', internalType: 'address', type: 'address' }],
    name: 'whitelisted',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'whitelistingEnabled',
    outputs: [{ name: '', internalType: 'bool', type: 'bool' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [{ name: 'amountCNS', internalType: 'uint256', type: 'uint256' }],
    name: 'withdrawCollateral',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'amountCNS', internalType: 'uint256', type: 'uint256' }],
    name: 'withdrawFromProtocol',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'amountCNS', internalType: 'uint256', type: 'uint256' }],
    name: 'xferAcctToProtocol',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'amountCNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'xferPerpInsToProtocol',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'accountId', internalType: 'uint256', type: 'uint256' },
      { name: 'amountCNS', internalType: 'uint256', type: 'uint256' },
    ],
    name: 'xferProtocolToAcct',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'perpId', internalType: 'uint256', type: 'uint256' },
      { name: 'amountCNS', internalType: 'uint256', type: 'uint256' },
      { name: 'insurance', internalType: 'bool', type: 'bool' },
    ],
    name: 'xferProtocolToPerp',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'amountCNS', internalType: 'uint256', type: 'uint256' }],
    name: 'xferProtocolToRecycleBal',
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Erc20ABIs
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const erc20AbIsAbi = [
  {
    type: 'event',
    inputs: [
      { name: 'owner', type: 'address', indexed: true },
      { name: 'spender', type: 'address', indexed: true },
      { name: 'value', type: 'uint256', indexed: false },
    ],
    name: 'Approval',
  },
  {
    type: 'event',
    inputs: [
      { name: 'from', type: 'address', indexed: true },
      { name: 'to', type: 'address', indexed: true },
      { name: 'value', type: 'uint256', indexed: false },
    ],
    name: 'Transfer',
  },
  {
    type: 'function',
    inputs: [
      { name: 'owner', type: 'address' },
      { name: 'spender', type: 'address' },
    ],
    name: 'allowance',
    outputs: [{ type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'spender', type: 'address' },
      { name: 'amount', type: 'uint256' },
    ],
    name: 'approve',
    outputs: [{ type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [{ name: 'account', type: 'address' }],
    name: 'balanceOf',
    outputs: [{ type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'decimals',
    outputs: [{ type: 'uint8' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'name',
    outputs: [{ type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'symbol',
    outputs: [{ type: 'string' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [],
    name: 'totalSupply',
    outputs: [{ type: 'uint256' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: 'recipient', type: 'address' },
      { name: 'amount', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ type: 'bool' }],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: 'sender', type: 'address' },
      { name: 'recipient', type: 'address' },
      { name: 'amount', type: 'uint256' },
    ],
    name: 'transferFrom',
    outputs: [{ type: 'bool' }],
    stateMutability: 'nonpayable',
  },
] as const

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// React
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__
 */
export const useReadDex = /*#__PURE__*/ createUseReadContract({ abi: dexAbi })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"addressBlocked"`
 */
export const useReadDexAddressBlocked = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'addressBlocked',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getAccountByAddr"`
 */
export const useReadDexGetAccountByAddr = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'getAccountByAddr',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getAccountById"`
 */
export const useReadDexGetAccountById = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'getAccountById',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getExchangeInfo"`
 */
export const useReadDexGetExchangeInfo = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'getExchangeInfo',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getFundingInterval"`
 */
export const useReadDexGetFundingInterval = /*#__PURE__*/ createUseReadContract(
  { abi: dexAbi, functionName: 'getFundingInterval' },
)

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getFundingSumAtBlock"`
 */
export const useReadDexGetFundingSumAtBlock =
  /*#__PURE__*/ createUseReadContract({
    abi: dexAbi,
    functionName: 'getFundingSumAtBlock',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getLiquidationInfo"`
 */
export const useReadDexGetLiquidationInfo = /*#__PURE__*/ createUseReadContract(
  { abi: dexAbi, functionName: 'getLiquidationInfo' },
)

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getMakerFee"`
 */
export const useReadDexGetMakerFee = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'getMakerFee',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getMarginFractions"`
 */
export const useReadDexGetMarginFractions = /*#__PURE__*/ createUseReadContract(
  { abi: dexAbi, functionName: 'getMarginFractions' },
)

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getMinAccountOpenCNS"`
 */
export const useReadDexGetMinAccountOpenCns =
  /*#__PURE__*/ createUseReadContract({
    abi: dexAbi,
    functionName: 'getMinAccountOpenCNS',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getMinimumPostCNS"`
 */
export const useReadDexGetMinimumPostCns = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'getMinimumPostCNS',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getMinimumSettleCNS"`
 */
export const useReadDexGetMinimumSettleCns =
  /*#__PURE__*/ createUseReadContract({
    abi: dexAbi,
    functionName: 'getMinimumSettleCNS',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getNextPriceAboveWithOrders"`
 */
export const useReadDexGetNextPriceAboveWithOrders =
  /*#__PURE__*/ createUseReadContract({
    abi: dexAbi,
    functionName: 'getNextPriceAboveWithOrders',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getNextPriceBelowWithOrders"`
 */
export const useReadDexGetNextPriceBelowWithOrders =
  /*#__PURE__*/ createUseReadContract({
    abi: dexAbi,
    functionName: 'getNextPriceBelowWithOrders',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getOrder"`
 */
export const useReadDexGetOrder = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'getOrder',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getOrderIdIndex"`
 */
export const useReadDexGetOrderIdIndex = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'getOrderIdIndex',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getOrderLocks"`
 */
export const useReadDexGetOrderLocks = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'getOrderLocks',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getOrdersAtPriceLevel"`
 */
export const useReadDexGetOrdersAtPriceLevel =
  /*#__PURE__*/ createUseReadContract({
    abi: dexAbi,
    functionName: 'getOrdersAtPriceLevel',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getOwner"`
 */
export const useReadDexGetOwner = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'getOwner',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getPermissionedCancelParams"`
 */
export const useReadDexGetPermissionedCancelParams =
  /*#__PURE__*/ createUseReadContract({
    abi: dexAbi,
    functionName: 'getPermissionedCancelParams',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getPerpOrderLocks"`
 */
export const useReadDexGetPerpOrderLocks = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'getPerpOrderLocks',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getPerpetualInfo"`
 */
export const useReadDexGetPerpetualInfo = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'getPerpetualInfo',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getPerpetualInfoV2"`
 */
export const useReadDexGetPerpetualInfoV2 = /*#__PURE__*/ createUseReadContract(
  { abi: dexAbi, functionName: 'getPerpetualInfoV2' },
)

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getPosition"`
 */
export const useReadDexGetPosition = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'getPosition',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getPositionIds"`
 */
export const useReadDexGetPositionIds = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'getPositionIds',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getPositionV2"`
 */
export const useReadDexGetPositionV2 = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'getPositionV2',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getPositions"`
 */
export const useReadDexGetPositions = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'getPositions',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getPositionsV2"`
 */
export const useReadDexGetPositionsV2 = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'getPositionsV2',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getPriceLevelOrderIds"`
 */
export const useReadDexGetPriceLevelOrderIds =
  /*#__PURE__*/ createUseReadContract({
    abi: dexAbi,
    functionName: 'getPriceLevelOrderIds',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getProtocolBalanceCNS"`
 */
export const useReadDexGetProtocolBalanceCns =
  /*#__PURE__*/ createUseReadContract({
    abi: dexAbi,
    functionName: 'getProtocolBalanceCNS',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getRecycleBalanceCNS"`
 */
export const useReadDexGetRecycleBalanceCns =
  /*#__PURE__*/ createUseReadContract({
    abi: dexAbi,
    functionName: 'getRecycleBalanceCNS',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getRecycleFeeCNS"`
 */
export const useReadDexGetRecycleFeeCns = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'getRecycleFeeCNS',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getTakerFee"`
 */
export const useReadDexGetTakerFee = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'getTakerFee',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getUnwindInfo"`
 */
export const useReadDexGetUnwindInfo = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'getUnwindInfo',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getVolumeAtBookPrice"`
 */
export const useReadDexGetVolumeAtBookPrice =
  /*#__PURE__*/ createUseReadContract({
    abi: dexAbi,
    functionName: 'getVolumeAtBookPrice',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"getWithdrawAllowanceData"`
 */
export const useReadDexGetWithdrawAllowanceData =
  /*#__PURE__*/ createUseReadContract({
    abi: dexAbi,
    functionName: 'getWithdrawAllowanceData',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"isAdministrator"`
 */
export const useReadDexIsAdministrator = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'isAdministrator',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"isHalted"`
 */
export const useReadDexIsHalted = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'isHalted',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"isLiquidationBuyer"`
 */
export const useReadDexIsLiquidationBuyer = /*#__PURE__*/ createUseReadContract(
  { abi: dexAbi, functionName: 'isLiquidationBuyer' },
)

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"isPositionAdministrator"`
 */
export const useReadDexIsPositionAdministrator =
  /*#__PURE__*/ createUseReadContract({
    abi: dexAbi,
    functionName: 'isPositionAdministrator',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"isPriceAdministrator"`
 */
export const useReadDexIsPriceAdministrator =
  /*#__PURE__*/ createUseReadContract({
    abi: dexAbi,
    functionName: 'isPriceAdministrator',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"isToleranceAdministrator"`
 */
export const useReadDexIsToleranceAdministrator =
  /*#__PURE__*/ createUseReadContract({
    abi: dexAbi,
    functionName: 'isToleranceAdministrator',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"numberOfAccounts"`
 */
export const useReadDexNumberOfAccounts = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'numberOfAccounts',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"owner"`
 */
export const useReadDexOwner = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'owner',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"pendingOwner"`
 */
export const useReadDexPendingOwner = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'pendingOwner',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"proxiableUUID"`
 */
export const useReadDexProxiableUuid = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'proxiableUUID',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"whitelisted"`
 */
export const useReadDexWhitelisted = /*#__PURE__*/ createUseReadContract({
  abi: dexAbi,
  functionName: 'whitelisted',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"whitelistingEnabled"`
 */
export const useReadDexWhitelistingEnabled =
  /*#__PURE__*/ createUseReadContract({
    abi: dexAbi,
    functionName: 'whitelistingEnabled',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__
 */
export const useWriteDex = /*#__PURE__*/ createUseWriteContract({ abi: dexAbi })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"acceptOwnership"`
 */
export const useWriteDexAcceptOwnership = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'acceptOwnership',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"addContract"`
 */
export const useWriteDexAddContract = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'addContract',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"adminCancelOrders"`
 */
export const useWriteDexAdminCancelOrders =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'adminCancelOrders',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"allowOrderForwarding"`
 */
export const useWriteDexAllowOrderForwarding =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'allowOrderForwarding',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"autoDeleverage"`
 */
export const useWriteDexAutoDeleverage = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'autoDeleverage',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"buyLiquidations"`
 */
export const useWriteDexBuyLiquidations = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'buyLiquidations',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"cancelDecreaseCollateralRequest"`
 */
export const useWriteDexCancelDecreaseCollateralRequest =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'cancelDecreaseCollateralRequest',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"clearInitUnwindContract"`
 */
export const useWriteDexClearInitUnwindContract =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'clearInitUnwindContract',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"clearOrderSlots"`
 */
export const useWriteDexClearOrderSlots = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'clearOrderSlots',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"clearPrepareUnwindContract"`
 */
export const useWriteDexClearPrepareUnwindContract =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'clearPrepareUnwindContract',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"clearPricePointerSlots"`
 */
export const useWriteDexClearPricePointerSlots =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'clearPricePointerSlots',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"createAccount"`
 */
export const useWriteDexCreateAccount = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'createAccount',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"declineDecreaseCollateralRequest"`
 */
export const useWriteDexDeclineDecreaseCollateralRequest =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'declineDecreaseCollateralRequest',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"decreasePositionCollateral"`
 */
export const useWriteDexDecreasePositionCollateral =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'decreasePositionCollateral',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"depositCollateral"`
 */
export const useWriteDexDepositCollateral =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'depositCollateral',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"depositToProtocol"`
 */
export const useWriteDexDepositToProtocol =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'depositToProtocol',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"execFwdPositionOps"`
 */
export const useWriteDexExecFwdPositionOps =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'execFwdPositionOps',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"execFznAccountPosOps"`
 */
export const useWriteDexExecFznAccountPosOps =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'execFznAccountPosOps',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"execOrder"`
 */
export const useWriteDexExecOrder = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'execOrder',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"execOrders"`
 */
export const useWriteDexExecOrders = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'execOrders',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"execPerpOps"`
 */
export const useWriteDexExecPerpOps = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'execPerpOps',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"forceClose"`
 */
export const useWriteDexForceClose = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'forceClose',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"forceResetWithdrawRateLimit"`
 */
export const useWriteDexForceResetWithdrawRateLimit =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'forceResetWithdrawRateLimit',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"increasePositionCollateral"`
 */
export const useWriteDexIncreasePositionCollateral =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'increasePositionCollateral',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"initUnwindContract"`
 */
export const useWriteDexInitUnwindContract =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'initUnwindContract',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"initialize"`
 */
export const useWriteDexInitialize = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'initialize',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"initializeV2"`
 */
export const useWriteDexInitializeV2 = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'initializeV2',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"liquidation"`
 */
export const useWriteDexLiquidation = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'liquidation',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"liquidations"`
 */
export const useWriteDexLiquidations = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'liquidations',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"pauseContract"`
 */
export const useWriteDexPauseContract = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'pauseContract',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"pauseContractByMonitor"`
 */
export const useWriteDexPauseContractByMonitor =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'pauseContractByMonitor',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"prepareUnwindContract"`
 */
export const useWriteDexPrepareUnwindContract =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'prepareUnwindContract',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"removeContract"`
 */
export const useWriteDexRemoveContract = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'removeContract',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useWriteDexRenounceOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"requestDecreasePositionCollateral"`
 */
export const useWriteDexRequestDecreasePositionCollateral =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'requestDecreasePositionCollateral',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setAddressBlockStatus"`
 */
export const useWriteDexSetAddressBlockStatus =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setAddressBlockStatus',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setAddressWhitelisted"`
 */
export const useWriteDexSetAddressWhitelisted =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setAddressWhitelisted',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setAdministrator"`
 */
export const useWriteDexSetAdministrator = /*#__PURE__*/ createUseWriteContract(
  { abi: dexAbi, functionName: 'setAdministrator' },
)

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setBuyToLiquidateBuyerRestriction"`
 */
export const useWriteDexSetBuyToLiquidateBuyerRestriction =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setBuyToLiquidateBuyerRestriction',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setBuyToLiquidateParams"`
 */
export const useWriteDexSetBuyToLiquidateParams =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setBuyToLiquidateParams',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setBuyToLiquidatePriceThreshold"`
 */
export const useWriteDexSetBuyToLiquidatePriceThreshold =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setBuyToLiquidatePriceThreshold',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setContractPaused"`
 */
export const useWriteDexSetContractPaused =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setContractPaused',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setDcpBorrowThreshold"`
 */
export const useWriteDexSetDcpBorrowThreshold =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setDcpBorrowThreshold',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setExchangeHalted"`
 */
export const useWriteDexSetExchangeHalted =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setExchangeHalted',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setFeeParams"`
 */
export const useWriteDexSetFeeParams = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'setFeeParams',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setFreezeStatus"`
 */
export const useWriteDexSetFreezeStatus = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'setFreezeStatus',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setFrozen"`
 */
export const useWriteDexSetFrozen = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'setFrozen',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setFundingClampPct"`
 */
export const useWriteDexSetFundingClampPct =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setFundingClampPct',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setFundingSum"`
 */
export const useWriteDexSetFundingSum = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'setFundingSum',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setFundingSumScalingExp"`
 */
export const useWriteDexSetFundingSumScalingExp =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setFundingSumScalingExp',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setIgnOracle"`
 */
export const useWriteDexSetIgnOracle = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'setIgnOracle',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setInitialMarginFraction"`
 */
export const useWriteDexSetInitialMarginFraction =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setInitialMarginFraction',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setLastForwardedDescId"`
 */
export const useWriteDexSetLastForwardedDescId =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setLastForwardedDescId',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setLastForwardedDescIdAsOwner"`
 */
export const useWriteDexSetLastForwardedDescIdAsOwner =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setLastForwardedDescIdAsOwner',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setLastTriggeredDescId"`
 */
export const useWriteDexSetLastTriggeredDescId =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setLastTriggeredDescId',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setLastTriggeredDescIdAsOwner"`
 */
export const useWriteDexSetLastTriggeredDescIdAsOwner =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setLastTriggeredDescIdAsOwner',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setLinkDsVerifier"`
 */
export const useWriteDexSetLinkDsVerifier =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setLinkDsVerifier',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setLiquidationBuyer"`
 */
export const useWriteDexSetLiquidationBuyer =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setLiquidationBuyer',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setLiquidationParams"`
 */
export const useWriteDexSetLiquidationParams =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setLiquidationParams',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setMaintenanceMarginFraction"`
 */
export const useWriteDexSetMaintenanceMarginFraction =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setMaintenanceMarginFraction',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setMakerFee"`
 */
export const useWriteDexSetMakerFee = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'setMakerFee',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setMarginTol"`
 */
export const useWriteDexSetMarginTol = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'setMarginTol',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setMaxOpenInterest"`
 */
export const useWriteDexSetMaxOpenInterest =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setMaxOpenInterest',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setMinAccountOpenAmount"`
 */
export const useWriteDexSetMinAccountOpenAmount =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setMinAccountOpenAmount',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setMinPost"`
 */
export const useWriteDexSetMinPost = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'setMinPost',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setMinSettle"`
 */
export const useWriteDexSetMinSettle = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'setMinSettle',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setMinWithdrawLimit"`
 */
export const useWriteDexSetMinWithdrawLimit =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setMinWithdrawLimit',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setMonitorAdministrator"`
 */
export const useWriteDexSetMonitorAdministrator =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setMonitorAdministrator',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setOverCollatDescentThreshold"`
 */
export const useWriteDexSetOverCollatDescentThreshold =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setOverCollatDescentThreshold',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setPermissionedCancelParams"`
 */
export const useWriteDexSetPermissionedCancelParams =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setPermissionedCancelParams',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setPerpLinkDsFeedId"`
 */
export const useWriteDexSetPerpLinkDsFeedId =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setPerpLinkDsFeedId',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setPositionAdministrator"`
 */
export const useWriteDexSetPositionAdministrator =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setPositionAdministrator',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setPriceAdministrator"`
 */
export const useWriteDexSetPriceAdministrator =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setPriceAdministrator',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setPriceMaxAge"`
 */
export const useWriteDexSetPriceMaxAge = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'setPriceMaxAge',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setPriceTolPer100K"`
 */
export const useWriteDexSetPriceTolPer100K =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setPriceTolPer100K',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setPriceTolPer100KByOwner"`
 */
export const useWriteDexSetPriceTolPer100KByOwner =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setPriceTolPer100KByOwner',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setRecycleFee"`
 */
export const useWriteDexSetRecycleFee = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'setRecycleFee',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setTakerFee"`
 */
export const useWriteDexSetTakerFee = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'setTakerFee',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setThousandthsTvlWRLS"`
 */
export const useWriteDexSetThousandthsTvlWrls =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setThousandthsTvlWRLS',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setToleranceAdministrator"`
 */
export const useWriteDexSetToleranceAdministrator =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setToleranceAdministrator',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setUnityDescentThreshold"`
 */
export const useWriteDexSetUnityDescentThreshold =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setUnityDescentThreshold',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setWhitelistingEnabled"`
 */
export const useWriteDexSetWhitelistingEnabled =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setWhitelistingEnabled',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setWithdrawBypass"`
 */
export const useWriteDexSetWithdrawBypass =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'setWithdrawBypass',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useWriteDexTransferOwnership =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"triggerUnwindContract"`
 */
export const useWriteDexTriggerUnwindContract =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'triggerUnwindContract',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"unwindContract"`
 */
export const useWriteDexUnwindContract = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'unwindContract',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"unwindContractByOwner"`
 */
export const useWriteDexUnwindContractByOwner =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'unwindContractByOwner',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"updateMarkPricePNS"`
 */
export const useWriteDexUpdateMarkPricePns =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'updateMarkPricePNS',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"updateMarkPricePNSByOwner"`
 */
export const useWriteDexUpdateMarkPricePnsByOwner =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'updateMarkPricePNSByOwner',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"updateOraclePrice"`
 */
export const useWriteDexUpdateOraclePrice =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'updateOraclePrice',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"upgradeTo"`
 */
export const useWriteDexUpgradeTo = /*#__PURE__*/ createUseWriteContract({
  abi: dexAbi,
  functionName: 'upgradeTo',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"upgradeToAndCall"`
 */
export const useWriteDexUpgradeToAndCall = /*#__PURE__*/ createUseWriteContract(
  { abi: dexAbi, functionName: 'upgradeToAndCall' },
)

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"withdrawCollateral"`
 */
export const useWriteDexWithdrawCollateral =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'withdrawCollateral',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"withdrawFromProtocol"`
 */
export const useWriteDexWithdrawFromProtocol =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'withdrawFromProtocol',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"xferAcctToProtocol"`
 */
export const useWriteDexXferAcctToProtocol =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'xferAcctToProtocol',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"xferPerpInsToProtocol"`
 */
export const useWriteDexXferPerpInsToProtocol =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'xferPerpInsToProtocol',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"xferProtocolToAcct"`
 */
export const useWriteDexXferProtocolToAcct =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'xferProtocolToAcct',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"xferProtocolToPerp"`
 */
export const useWriteDexXferProtocolToPerp =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'xferProtocolToPerp',
  })

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"xferProtocolToRecycleBal"`
 */
export const useWriteDexXferProtocolToRecycleBal =
  /*#__PURE__*/ createUseWriteContract({
    abi: dexAbi,
    functionName: 'xferProtocolToRecycleBal',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__
 */
export const useSimulateDex = /*#__PURE__*/ createUseSimulateContract({
  abi: dexAbi,
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"acceptOwnership"`
 */
export const useSimulateDexAcceptOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'acceptOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"addContract"`
 */
export const useSimulateDexAddContract =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'addContract',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"adminCancelOrders"`
 */
export const useSimulateDexAdminCancelOrders =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'adminCancelOrders',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"allowOrderForwarding"`
 */
export const useSimulateDexAllowOrderForwarding =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'allowOrderForwarding',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"autoDeleverage"`
 */
export const useSimulateDexAutoDeleverage =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'autoDeleverage',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"buyLiquidations"`
 */
export const useSimulateDexBuyLiquidations =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'buyLiquidations',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"cancelDecreaseCollateralRequest"`
 */
export const useSimulateDexCancelDecreaseCollateralRequest =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'cancelDecreaseCollateralRequest',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"clearInitUnwindContract"`
 */
export const useSimulateDexClearInitUnwindContract =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'clearInitUnwindContract',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"clearOrderSlots"`
 */
export const useSimulateDexClearOrderSlots =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'clearOrderSlots',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"clearPrepareUnwindContract"`
 */
export const useSimulateDexClearPrepareUnwindContract =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'clearPrepareUnwindContract',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"clearPricePointerSlots"`
 */
export const useSimulateDexClearPricePointerSlots =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'clearPricePointerSlots',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"createAccount"`
 */
export const useSimulateDexCreateAccount =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'createAccount',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"declineDecreaseCollateralRequest"`
 */
export const useSimulateDexDeclineDecreaseCollateralRequest =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'declineDecreaseCollateralRequest',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"decreasePositionCollateral"`
 */
export const useSimulateDexDecreasePositionCollateral =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'decreasePositionCollateral',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"depositCollateral"`
 */
export const useSimulateDexDepositCollateral =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'depositCollateral',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"depositToProtocol"`
 */
export const useSimulateDexDepositToProtocol =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'depositToProtocol',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"execFwdPositionOps"`
 */
export const useSimulateDexExecFwdPositionOps =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'execFwdPositionOps',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"execFznAccountPosOps"`
 */
export const useSimulateDexExecFznAccountPosOps =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'execFznAccountPosOps',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"execOrder"`
 */
export const useSimulateDexExecOrder = /*#__PURE__*/ createUseSimulateContract({
  abi: dexAbi,
  functionName: 'execOrder',
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"execOrders"`
 */
export const useSimulateDexExecOrders = /*#__PURE__*/ createUseSimulateContract(
  { abi: dexAbi, functionName: 'execOrders' },
)

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"execPerpOps"`
 */
export const useSimulateDexExecPerpOps =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'execPerpOps',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"forceClose"`
 */
export const useSimulateDexForceClose = /*#__PURE__*/ createUseSimulateContract(
  { abi: dexAbi, functionName: 'forceClose' },
)

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"forceResetWithdrawRateLimit"`
 */
export const useSimulateDexForceResetWithdrawRateLimit =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'forceResetWithdrawRateLimit',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"increasePositionCollateral"`
 */
export const useSimulateDexIncreasePositionCollateral =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'increasePositionCollateral',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"initUnwindContract"`
 */
export const useSimulateDexInitUnwindContract =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'initUnwindContract',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"initialize"`
 */
export const useSimulateDexInitialize = /*#__PURE__*/ createUseSimulateContract(
  { abi: dexAbi, functionName: 'initialize' },
)

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"initializeV2"`
 */
export const useSimulateDexInitializeV2 =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'initializeV2',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"liquidation"`
 */
export const useSimulateDexLiquidation =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'liquidation',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"liquidations"`
 */
export const useSimulateDexLiquidations =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'liquidations',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"pauseContract"`
 */
export const useSimulateDexPauseContract =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'pauseContract',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"pauseContractByMonitor"`
 */
export const useSimulateDexPauseContractByMonitor =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'pauseContractByMonitor',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"prepareUnwindContract"`
 */
export const useSimulateDexPrepareUnwindContract =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'prepareUnwindContract',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"removeContract"`
 */
export const useSimulateDexRemoveContract =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'removeContract',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"renounceOwnership"`
 */
export const useSimulateDexRenounceOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'renounceOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"requestDecreasePositionCollateral"`
 */
export const useSimulateDexRequestDecreasePositionCollateral =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'requestDecreasePositionCollateral',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setAddressBlockStatus"`
 */
export const useSimulateDexSetAddressBlockStatus =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setAddressBlockStatus',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setAddressWhitelisted"`
 */
export const useSimulateDexSetAddressWhitelisted =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setAddressWhitelisted',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setAdministrator"`
 */
export const useSimulateDexSetAdministrator =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setAdministrator',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setBuyToLiquidateBuyerRestriction"`
 */
export const useSimulateDexSetBuyToLiquidateBuyerRestriction =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setBuyToLiquidateBuyerRestriction',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setBuyToLiquidateParams"`
 */
export const useSimulateDexSetBuyToLiquidateParams =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setBuyToLiquidateParams',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setBuyToLiquidatePriceThreshold"`
 */
export const useSimulateDexSetBuyToLiquidatePriceThreshold =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setBuyToLiquidatePriceThreshold',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setContractPaused"`
 */
export const useSimulateDexSetContractPaused =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setContractPaused',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setDcpBorrowThreshold"`
 */
export const useSimulateDexSetDcpBorrowThreshold =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setDcpBorrowThreshold',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setExchangeHalted"`
 */
export const useSimulateDexSetExchangeHalted =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setExchangeHalted',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setFeeParams"`
 */
export const useSimulateDexSetFeeParams =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setFeeParams',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setFreezeStatus"`
 */
export const useSimulateDexSetFreezeStatus =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setFreezeStatus',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setFrozen"`
 */
export const useSimulateDexSetFrozen = /*#__PURE__*/ createUseSimulateContract({
  abi: dexAbi,
  functionName: 'setFrozen',
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setFundingClampPct"`
 */
export const useSimulateDexSetFundingClampPct =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setFundingClampPct',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setFundingSum"`
 */
export const useSimulateDexSetFundingSum =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setFundingSum',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setFundingSumScalingExp"`
 */
export const useSimulateDexSetFundingSumScalingExp =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setFundingSumScalingExp',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setIgnOracle"`
 */
export const useSimulateDexSetIgnOracle =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setIgnOracle',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setInitialMarginFraction"`
 */
export const useSimulateDexSetInitialMarginFraction =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setInitialMarginFraction',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setLastForwardedDescId"`
 */
export const useSimulateDexSetLastForwardedDescId =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setLastForwardedDescId',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setLastForwardedDescIdAsOwner"`
 */
export const useSimulateDexSetLastForwardedDescIdAsOwner =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setLastForwardedDescIdAsOwner',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setLastTriggeredDescId"`
 */
export const useSimulateDexSetLastTriggeredDescId =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setLastTriggeredDescId',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setLastTriggeredDescIdAsOwner"`
 */
export const useSimulateDexSetLastTriggeredDescIdAsOwner =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setLastTriggeredDescIdAsOwner',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setLinkDsVerifier"`
 */
export const useSimulateDexSetLinkDsVerifier =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setLinkDsVerifier',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setLiquidationBuyer"`
 */
export const useSimulateDexSetLiquidationBuyer =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setLiquidationBuyer',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setLiquidationParams"`
 */
export const useSimulateDexSetLiquidationParams =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setLiquidationParams',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setMaintenanceMarginFraction"`
 */
export const useSimulateDexSetMaintenanceMarginFraction =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setMaintenanceMarginFraction',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setMakerFee"`
 */
export const useSimulateDexSetMakerFee =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setMakerFee',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setMarginTol"`
 */
export const useSimulateDexSetMarginTol =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setMarginTol',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setMaxOpenInterest"`
 */
export const useSimulateDexSetMaxOpenInterest =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setMaxOpenInterest',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setMinAccountOpenAmount"`
 */
export const useSimulateDexSetMinAccountOpenAmount =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setMinAccountOpenAmount',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setMinPost"`
 */
export const useSimulateDexSetMinPost = /*#__PURE__*/ createUseSimulateContract(
  { abi: dexAbi, functionName: 'setMinPost' },
)

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setMinSettle"`
 */
export const useSimulateDexSetMinSettle =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setMinSettle',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setMinWithdrawLimit"`
 */
export const useSimulateDexSetMinWithdrawLimit =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setMinWithdrawLimit',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setMonitorAdministrator"`
 */
export const useSimulateDexSetMonitorAdministrator =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setMonitorAdministrator',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setOverCollatDescentThreshold"`
 */
export const useSimulateDexSetOverCollatDescentThreshold =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setOverCollatDescentThreshold',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setPermissionedCancelParams"`
 */
export const useSimulateDexSetPermissionedCancelParams =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setPermissionedCancelParams',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setPerpLinkDsFeedId"`
 */
export const useSimulateDexSetPerpLinkDsFeedId =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setPerpLinkDsFeedId',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setPositionAdministrator"`
 */
export const useSimulateDexSetPositionAdministrator =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setPositionAdministrator',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setPriceAdministrator"`
 */
export const useSimulateDexSetPriceAdministrator =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setPriceAdministrator',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setPriceMaxAge"`
 */
export const useSimulateDexSetPriceMaxAge =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setPriceMaxAge',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setPriceTolPer100K"`
 */
export const useSimulateDexSetPriceTolPer100K =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setPriceTolPer100K',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setPriceTolPer100KByOwner"`
 */
export const useSimulateDexSetPriceTolPer100KByOwner =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setPriceTolPer100KByOwner',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setRecycleFee"`
 */
export const useSimulateDexSetRecycleFee =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setRecycleFee',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setTakerFee"`
 */
export const useSimulateDexSetTakerFee =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setTakerFee',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setThousandthsTvlWRLS"`
 */
export const useSimulateDexSetThousandthsTvlWrls =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setThousandthsTvlWRLS',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setToleranceAdministrator"`
 */
export const useSimulateDexSetToleranceAdministrator =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setToleranceAdministrator',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setUnityDescentThreshold"`
 */
export const useSimulateDexSetUnityDescentThreshold =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setUnityDescentThreshold',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setWhitelistingEnabled"`
 */
export const useSimulateDexSetWhitelistingEnabled =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setWhitelistingEnabled',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"setWithdrawBypass"`
 */
export const useSimulateDexSetWithdrawBypass =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'setWithdrawBypass',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"transferOwnership"`
 */
export const useSimulateDexTransferOwnership =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'transferOwnership',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"triggerUnwindContract"`
 */
export const useSimulateDexTriggerUnwindContract =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'triggerUnwindContract',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"unwindContract"`
 */
export const useSimulateDexUnwindContract =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'unwindContract',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"unwindContractByOwner"`
 */
export const useSimulateDexUnwindContractByOwner =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'unwindContractByOwner',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"updateMarkPricePNS"`
 */
export const useSimulateDexUpdateMarkPricePns =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'updateMarkPricePNS',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"updateMarkPricePNSByOwner"`
 */
export const useSimulateDexUpdateMarkPricePnsByOwner =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'updateMarkPricePNSByOwner',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"updateOraclePrice"`
 */
export const useSimulateDexUpdateOraclePrice =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'updateOraclePrice',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"upgradeTo"`
 */
export const useSimulateDexUpgradeTo = /*#__PURE__*/ createUseSimulateContract({
  abi: dexAbi,
  functionName: 'upgradeTo',
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"upgradeToAndCall"`
 */
export const useSimulateDexUpgradeToAndCall =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'upgradeToAndCall',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"withdrawCollateral"`
 */
export const useSimulateDexWithdrawCollateral =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'withdrawCollateral',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"withdrawFromProtocol"`
 */
export const useSimulateDexWithdrawFromProtocol =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'withdrawFromProtocol',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"xferAcctToProtocol"`
 */
export const useSimulateDexXferAcctToProtocol =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'xferAcctToProtocol',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"xferPerpInsToProtocol"`
 */
export const useSimulateDexXferPerpInsToProtocol =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'xferPerpInsToProtocol',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"xferProtocolToAcct"`
 */
export const useSimulateDexXferProtocolToAcct =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'xferProtocolToAcct',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"xferProtocolToPerp"`
 */
export const useSimulateDexXferProtocolToPerp =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'xferProtocolToPerp',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link dexAbi}__ and `functionName` set to `"xferProtocolToRecycleBal"`
 */
export const useSimulateDexXferProtocolToRecycleBal =
  /*#__PURE__*/ createUseSimulateContract({
    abi: dexAbi,
    functionName: 'xferProtocolToRecycleBal',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__
 */
export const useWatchDexEvent = /*#__PURE__*/ createUseWatchContractEvent({
  abi: dexAbi,
})

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"AccountCreated"`
 */
export const useWatchDexAccountCreatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'AccountCreated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"AccountFreeze"`
 */
export const useWatchDexAccountFreezeEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'AccountFreeze',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"AccountFrozen"`
 */
export const useWatchDexAccountFrozenEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'AccountFrozen',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"AccountLiquidationCredit"`
 */
export const useWatchDexAccountLiquidationCreditEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'AccountLiquidationCredit',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"AdminChanged"`
 */
export const useWatchDexAdminChangedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'AdminChanged',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"AdministratorUpdated"`
 */
export const useWatchDexAdministratorUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'AdministratorUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"AmountExceedsAvailableBalance"`
 */
export const useWatchDexAmountExceedsAvailableBalanceEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'AmountExceedsAvailableBalance',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"BankruptcyPricePreventsDeleverage"`
 */
export const useWatchDexBankruptcyPricePreventsDeleverageEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'BankruptcyPricePreventsDeleverage',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"BeaconUpgraded"`
 */
export const useWatchDexBeaconUpgradedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'BeaconUpgraded',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"BlockStatusChanged"`
 */
export const useWatchDexBlockStatusChangedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'BlockStatusChanged',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"BorrowMarginNotMetAfterDecCollateral"`
 */
export const useWatchDexBorrowMarginNotMetAfterDecCollateralEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'BorrowMarginNotMetAfterDecCollateral',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"BuyToLiquidateBuyerRestricted"`
 */
export const useWatchDexBuyToLiquidateBuyerRestrictedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'BuyToLiquidateBuyerRestricted',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"BuyToLiquidateParamsUpdated"`
 */
export const useWatchDexBuyToLiquidateParamsUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'BuyToLiquidateParamsUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"BuyToLiquidateRestrictionUpdated"`
 */
export const useWatchDexBuyToLiquidateRestrictionUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'BuyToLiquidateRestrictionUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"BuyToLiquidateSettled"`
 */
export const useWatchDexBuyToLiquidateSettledEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'BuyToLiquidateSettled',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"BuyToLiquidateSlippageExceeded"`
 */
export const useWatchDexBuyToLiquidateSlippageExceededEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'BuyToLiquidateSlippageExceeded',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"BuyToLiquidateStarted"`
 */
export const useWatchDexBuyToLiquidateStartedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'BuyToLiquidateStarted',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"BuyToLiquidateThresholdUpdated"`
 */
export const useWatchDexBuyToLiquidateThresholdUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'BuyToLiquidateThresholdUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"CancelExistingInvalidCloseOrders"`
 */
export const useWatchDexCancelExistingInvalidCloseOrdersEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'CancelExistingInvalidCloseOrders',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"CannotAdjustEntryPriceToDecCollateral"`
 */
export const useWatchDexCannotAdjustEntryPriceToDecCollateralEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'CannotAdjustEntryPriceToDecCollateral',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"CantBuyToLiquidate"`
 */
export const useWatchDexCantBuyToLiquidateEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'CantBuyToLiquidate',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"CantChangeCloseOrder"`
 */
export const useWatchDexCantChangeCloseOrderEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'CantChangeCloseOrder',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"CantDeleverageAgainstOpposingPositions"`
 */
export const useWatchDexCantDeleverageAgainstOpposingPositionsEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'CantDeleverageAgainstOpposingPositions',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"CantLiquidatePosAboveMMR"`
 */
export const useWatchDexCantLiquidatePosAboveMmrEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'CantLiquidatePosAboveMMR',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ChangeExpiredOrderNeedsNewExpiry"`
 */
export const useWatchDexChangeExpiredOrderNeedsNewExpiryEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ChangeExpiredOrderNeedsNewExpiry',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ClearingExpiredOrder"`
 */
export const useWatchDexClearingExpiredOrderEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ClearingExpiredOrder',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ClearingFrozenAccountOrder"`
 */
export const useWatchDexClearingFrozenAccountOrderEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ClearingFrozenAccountOrder',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ClearingInvalidCloseOrder"`
 */
export const useWatchDexClearingInvalidCloseOrderEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ClearingInvalidCloseOrder',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ClearingRemainingOrderLockBeyondBalance"`
 */
export const useWatchDexClearingRemainingOrderLockBeyondBalanceEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ClearingRemainingOrderLockBeyondBalance',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ClearingSelfMatchingOrder"`
 */
export const useWatchDexClearingSelfMatchingOrderEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ClearingSelfMatchingOrder',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"CloseOrderExceedsPosition"`
 */
export const useWatchDexCloseOrderExceedsPositionEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'CloseOrderExceedsPosition',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"CloseOrderPositionMismatch"`
 */
export const useWatchDexCloseOrderPositionMismatchEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'CloseOrderPositionMismatch',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"CollateralDecreaseDeclined"`
 */
export const useWatchDexCollateralDecreaseDeclinedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'CollateralDecreaseDeclined',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"CollateralDecreaseRequestCancelled"`
 */
export const useWatchDexCollateralDecreaseRequestCancelledEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'CollateralDecreaseRequestCancelled',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"CollateralDecreaseRequestExpired"`
 */
export const useWatchDexCollateralDecreaseRequestExpiredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'CollateralDecreaseRequestExpired',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"CollateralDecreaseRequested"`
 */
export const useWatchDexCollateralDecreaseRequestedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'CollateralDecreaseRequested',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"CollateralDeposit"`
 */
export const useWatchDexCollateralDepositEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'CollateralDeposit',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"CollateralWithdrawal"`
 */
export const useWatchDexCollateralWithdrawalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'CollateralWithdrawal',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ContractAdded"`
 */
export const useWatchDexContractAddedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ContractAdded',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ContractLinkFeedUpdated"`
 */
export const useWatchDexContractLinkFeedUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ContractLinkFeedUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ContractNotOperational"`
 */
export const useWatchDexContractNotOperationalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ContractNotOperational',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ContractPaused"`
 */
export const useWatchDexContractPausedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ContractPaused',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ContractRemoved"`
 */
export const useWatchDexContractRemovedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ContractRemoved',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"CrossesBook"`
 */
export const useWatchDexCrossesBookEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'CrossesBook',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"DcpBorrowThreshUpdated"`
 */
export const useWatchDexDcpBorrowThreshUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'DcpBorrowThreshUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"DecreaseCollateralBeyondMarkPrice"`
 */
export const useWatchDexDecreaseCollateralBeyondMarkPriceEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'DecreaseCollateralBeyondMarkPrice',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"DeleveragePositionListEmpty"`
 */
export const useWatchDexDeleveragePositionListEmptyEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'DeleveragePositionListEmpty',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ExceedsLastExecutionBlock"`
 */
export const useWatchDexExceedsLastExecutionBlockEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ExceedsLastExecutionBlock',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ExchangeHalted"`
 */
export const useWatchDexExchangeHaltedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ExchangeHalted',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ExchangeInitialized"`
 */
export const useWatchDexExchangeInitializedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ExchangeInitialized',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"FeeParamsUpdated"`
 */
export const useWatchDexFeeParamsUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'FeeParamsUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"FundingClampPctUpdated"`
 */
export const useWatchDexFundingClampPctUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'FundingClampPctUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"FundingEventCompleted"`
 */
export const useWatchDexFundingEventCompletedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'FundingEventCompleted',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"FundingEventSetTooEarly"`
 */
export const useWatchDexFundingEventSetTooEarlyEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'FundingEventSetTooEarly',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"FundingPriceExceedsTol"`
 */
export const useWatchDexFundingPriceExceedsTolEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'FundingPriceExceedsTol',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"FundingSumAlreadySet"`
 */
export const useWatchDexFundingSumAlreadySetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'FundingSumAlreadySet',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"FundingSumScalingExpUpdated"`
 */
export const useWatchDexFundingSumScalingExpUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'FundingSumScalingExpUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"IgnoreOracleUpdated"`
 */
export const useWatchDexIgnoreOracleUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'IgnoreOracleUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ImmediateOrCancelExecuted"`
 */
export const useWatchDexImmediateOrCancelExecutedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ImmediateOrCancelExecuted',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"IncreasePositionCollateral"`
 */
export const useWatchDexIncreasePositionCollateralEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'IncreasePositionCollateral',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"InitialMarginFractionUpdated"`
 */
export const useWatchDexInitialMarginFractionUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'InitialMarginFractionUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"Initialized"`
 */
export const useWatchDexInitializedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'Initialized',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"InsolventPositionCannotBeForcedClose"`
 */
export const useWatchDexInsolventPositionCannotBeForcedCloseEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'InsolventPositionCannotBeForcedClose',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"InsufficientFundsToDecCollateral"`
 */
export const useWatchDexInsufficientFundsToDecCollateralEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'InsufficientFundsToDecCollateral',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"InsuficientFundsForRecycleFee"`
 */
export const useWatchDexInsuficientFundsForRecycleFeeEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'InsuficientFundsForRecycleFee',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"InsurancePaymentForSettlement"`
 */
export const useWatchDexInsurancePaymentForSettlementEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'InsurancePaymentForSettlement',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"InvalidAccountFrozenOrder"`
 */
export const useWatchDexInvalidAccountFrozenOrderEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'InvalidAccountFrozenOrder',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"InvalidBankruptcyPrice"`
 */
export const useWatchDexInvalidBankruptcyPriceEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'InvalidBankruptcyPrice',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"InvalidExpiryBlock"`
 */
export const useWatchDexInvalidExpiryBlockEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'InvalidExpiryBlock',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"InvalidLinkReportForContract"`
 */
export const useWatchDexInvalidLinkReportForContractEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'InvalidLinkReportForContract',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"InvalidLinkReportVersion"`
 */
export const useWatchDexInvalidLinkReportVersionEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'InvalidLinkReportVersion',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"InvalidLiquidationPrice"`
 */
export const useWatchDexInvalidLiquidationPriceEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'InvalidLiquidationPrice',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"InvalidOrderId"`
 */
export const useWatchDexInvalidOrderIdEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'InvalidOrderId',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"LastForwardedDescIdReset"`
 */
export const useWatchDexLastForwardedDescIdResetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'LastForwardedDescIdReset',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"LastTriggeredDescIdReset"`
 */
export const useWatchDexLastTriggeredDescIdResetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'LastTriggeredDescIdReset',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"LinkDatastreamConfigured"`
 */
export const useWatchDexLinkDatastreamConfiguredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'LinkDatastreamConfigured',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"LinkDsError"`
 */
export const useWatchDexLinkDsErrorEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'LinkDsError',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"LinkDsPanic"`
 */
export const useWatchDexLinkDsPanicEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'LinkDsPanic',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"LinkPriceUpdated"`
 */
export const useWatchDexLinkPriceUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'LinkPriceUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"LiquidationBuyerUpdated"`
 */
export const useWatchDexLiquidationBuyerUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'LiquidationBuyerUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"LiquidationParamsUpdated"`
 */
export const useWatchDexLiquidationParamsUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'LiquidationParamsUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"LotOutOfRange"`
 */
export const useWatchDexLotOutOfRangeEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'LotOutOfRange',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"MaintenanceMarginFractionUpdated"`
 */
export const useWatchDexMaintenanceMarginFractionUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'MaintenanceMarginFractionUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"MakerFeeUpdated"`
 */
export const useWatchDexMakerFeeUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'MakerFeeUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"MakerOrderFilled"`
 */
export const useWatchDexMakerOrderFilledEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'MakerOrderFilled',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"MakerOrderSettlementFailed"`
 */
export const useWatchDexMakerOrderSettlementFailedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'MakerOrderSettlementFailed',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"MarginTolUpdated"`
 */
export const useWatchDexMarginTolUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'MarginTolUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"MarkExceedsTol"`
 */
export const useWatchDexMarkExceedsTolEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'MarkExceedsTol',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"MarkPriceAgeExceedsMax"`
 */
export const useWatchDexMarkPriceAgeExceedsMaxEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'MarkPriceAgeExceedsMax',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"MarkUpdated"`
 */
export const useWatchDexMarkUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'MarkUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"MaxMatchesReached"`
 */
export const useWatchDexMaxMatchesReachedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'MaxMatchesReached',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"MaxOpenInterestUpdated"`
 */
export const useWatchDexMaxOpenInterestUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'MaxOpenInterestUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"MaximumAccountOrders"`
 */
export const useWatchDexMaximumAccountOrdersEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'MaximumAccountOrders',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"MinAccountOpenAmountUpdated"`
 */
export const useWatchDexMinAccountOpenAmountUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'MinAccountOpenAmountUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"MinPostUpdated"`
 */
export const useWatchDexMinPostUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'MinPostUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"MinSettleUpdated"`
 */
export const useWatchDexMinSettleUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'MinSettleUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"MonitorAdministratorUpdated"`
 */
export const useWatchDexMonitorAdministratorUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'MonitorAdministratorUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"MonitorPauseAttempted"`
 */
export const useWatchDexMonitorPauseAttemptedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'MonitorPauseAttempted',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"OracleAgeExceedsMax"`
 */
export const useWatchDexOracleAgeExceedsMaxEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'OracleAgeExceedsMax',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"OracleDisabled"`
 */
export const useWatchDexOracleDisabledEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'OracleDisabled',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"OrderBatchCompleted"`
 */
export const useWatchDexOrderBatchCompletedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'OrderBatchCompleted',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"OrderCancelled"`
 */
export const useWatchDexOrderCancelledEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'OrderCancelled',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"OrderCancelledByAdmin"`
 */
export const useWatchDexOrderCancelledByAdminEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'OrderCancelledByAdmin',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"OrderCancelledByLiquidator"`
 */
export const useWatchDexOrderCancelledByLiquidatorEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'OrderCancelledByLiquidator',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"OrderChanged"`
 */
export const useWatchDexOrderChangedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'OrderChanged',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"OrderDescIdTooLow"`
 */
export const useWatchDexOrderDescIdTooLowEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'OrderDescIdTooLow',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"OrderDoesNotExist"`
 */
export const useWatchDexOrderDoesNotExistEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'OrderDoesNotExist',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"OrderForwardingNotAllowed"`
 */
export const useWatchDexOrderForwardingNotAllowedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'OrderForwardingNotAllowed',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"OrderForwardingUpdated"`
 */
export const useWatchDexOrderForwardingUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'OrderForwardingUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"OrderPlaced"`
 */
export const useWatchDexOrderPlacedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'OrderPlaced',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"OrderPostFailed"`
 */
export const useWatchDexOrderPostFailedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'OrderPostFailed',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"OrderRequest"`
 */
export const useWatchDexOrderRequestEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'OrderRequest',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"OrderSettlementImpliesInsolvent"`
 */
export const useWatchDexOrderSettlementImpliesInsolventEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'OrderSettlementImpliesInsolvent',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"OrderSizeExceedsAvailableSize"`
 */
export const useWatchDexOrderSizeExceedsAvailableSizeEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'OrderSizeExceedsAvailableSize',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"OverCollatDescentThreshUpdated"`
 */
export const useWatchDexOverCollatDescentThreshUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'OverCollatDescentThreshUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"OwnershipTransferStarted"`
 */
export const useWatchDexOwnershipTransferStartedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'OwnershipTransferStarted',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"OwnershipTransferred"`
 */
export const useWatchDexOwnershipTransferredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'OwnershipTransferred',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PermissonedCancelParamsUpdated"`
 */
export const useWatchDexPermissonedCancelParamsUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PermissonedCancelParamsUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PerpPositionBalCreditPositiveSevere"`
 */
export const useWatchDexPerpPositionBalCreditPositiveSevereEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PerpPositionBalCreditPositiveSevere',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PositionAdministratorUpdated"`
 */
export const useWatchDexPositionAdministratorUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PositionAdministratorUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PositionClosed"`
 */
export const useWatchDexPositionClosedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PositionClosed',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PositionCollateralDecreased"`
 */
export const useWatchDexPositionCollateralDecreasedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PositionCollateralDecreased',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PositionDecreased"`
 */
export const useWatchDexPositionDecreasedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PositionDecreased',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PositionDeleveraged"`
 */
export const useWatchDexPositionDeleveragedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PositionDeleveraged',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PositionDeleveragedV2"`
 */
export const useWatchDexPositionDeleveragedV2Event =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PositionDeleveragedV2',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PositionDoesNotExist"`
 */
export const useWatchDexPositionDoesNotExistEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PositionDoesNotExist',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PositionIncreased"`
 */
export const useWatchDexPositionIncreasedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PositionIncreased',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PositionIncreasedV2"`
 */
export const useWatchDexPositionIncreasedV2Event =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PositionIncreasedV2',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PositionInverted"`
 */
export const useWatchDexPositionInvertedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PositionInverted',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PositionLiquidated"`
 */
export const useWatchDexPositionLiquidatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PositionLiquidated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PositionLiquidationCredit"`
 */
export const useWatchDexPositionLiquidationCreditEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PositionLiquidationCredit',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PositionOpened"`
 */
export const useWatchDexPositionOpenedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PositionOpened',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PositionOpenedV2"`
 */
export const useWatchDexPositionOpenedV2Event =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PositionOpenedV2',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PositionUnwound"`
 */
export const useWatchDexPositionUnwoundEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PositionUnwound',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PositionUnwoundV2"`
 */
export const useWatchDexPositionUnwoundV2Event =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PositionUnwoundV2',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PositionUnwoundWithoutPayment"`
 */
export const useWatchDexPositionUnwoundWithoutPaymentEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PositionUnwoundWithoutPayment',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PositionUnwoundWithoutPaymentV2"`
 */
export const useWatchDexPositionUnwoundWithoutPaymentV2Event =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PositionUnwoundWithoutPaymentV2',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PostOrderUnderMinimum"`
 */
export const useWatchDexPostOrderUnderMinimumEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PostOrderUnderMinimum',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PriceAdministratorUpdated"`
 */
export const useWatchDexPriceAdministratorUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PriceAdministratorUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PriceMaxAgeUpdated"`
 */
export const useWatchDexPriceMaxAgeUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PriceMaxAgeUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PriceOutOfRange"`
 */
export const useWatchDexPriceOutOfRangeEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PriceOutOfRange',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PriceSetDuringTriggerExec"`
 */
export const useWatchDexPriceSetDuringTriggerExecEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PriceSetDuringTriggerExec',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"PriceTolUpdated"`
 */
export const useWatchDexPriceTolUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'PriceTolUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ProtocolBalanceDeposit"`
 */
export const useWatchDexProtocolBalanceDepositEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ProtocolBalanceDeposit',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ProtocolBalanceWithdraw"`
 */
export const useWatchDexProtocolBalanceWithdrawEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ProtocolBalanceWithdraw',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"RecycleBalanceInsufficientSevere"`
 */
export const useWatchDexRecycleBalanceInsufficientSevereEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'RecycleBalanceInsufficientSevere',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"RecycleFeeToAccount"`
 */
export const useWatchDexRecycleFeeToAccountEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'RecycleFeeToAccount',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"RecycleFeeToProtocol"`
 */
export const useWatchDexRecycleFeeToProtocolEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'RecycleFeeToProtocol',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"RecycleFeeUpdated"`
 */
export const useWatchDexRecycleFeeUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'RecycleFeeUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ReportAgeExceedsLastUpdate"`
 */
export const useWatchDexReportAgeExceedsLastUpdateEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ReportAgeExceedsLastUpdate',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ReportExpiresTooSoon"`
 */
export const useWatchDexReportExpiresTooSoonEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ReportExpiresTooSoon',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ReportFromFuture"`
 */
export const useWatchDexReportFromFutureEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ReportFromFuture',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ReportPriceIsNegative"`
 */
export const useWatchDexReportPriceIsNegativeEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ReportPriceIsNegative',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ResidueBalanceInsufficient"`
 */
export const useWatchDexResidueBalanceInsufficientEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ResidueBalanceInsufficient',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ResidueTransferred"`
 */
export const useWatchDexResidueTransferredEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ResidueTransferred',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"TakerFeeUpdated"`
 */
export const useWatchDexTakerFeeUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'TakerFeeUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"TakerOrderFilled"`
 */
export const useWatchDexTakerOrderFilledEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'TakerOrderFilled',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ToleranceAdministratorUpdated"`
 */
export const useWatchDexToleranceAdministratorUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ToleranceAdministratorUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"TransferAccountToProtocol"`
 */
export const useWatchDexTransferAccountToProtocolEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'TransferAccountToProtocol',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"TransferPerpInsToProtocol"`
 */
export const useWatchDexTransferPerpInsToProtocolEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'TransferPerpInsToProtocol',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"TransferPerpPosToProtocol"`
 */
export const useWatchDexTransferPerpPosToProtocolEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'TransferPerpPosToProtocol',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"TransferProtocolToAccount"`
 */
export const useWatchDexTransferProtocolToAccountEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'TransferProtocolToAccount',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"TransferProtocolToPerp"`
 */
export const useWatchDexTransferProtocolToPerpEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'TransferProtocolToPerp',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"TransferProtocolToRecycleBal"`
 */
export const useWatchDexTransferProtocolToRecycleBalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'TransferProtocolToRecycleBal',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"TriggerDescIdTooLow"`
 */
export const useWatchDexTriggerDescIdTooLowEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'TriggerDescIdTooLow',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"TriggerOrderExecution"`
 */
export const useWatchDexTriggerOrderExecutionEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'TriggerOrderExecution',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"TriggerOrderRequest"`
 */
export const useWatchDexTriggerOrderRequestEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'TriggerOrderRequest',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"UnableToCancelOrder"`
 */
export const useWatchDexUnableToCancelOrderEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'UnableToCancelOrder',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"UnityDescentThreshUpdated"`
 */
export const useWatchDexUnityDescentThreshUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'UnityDescentThreshUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"UnspecifiedCollateral"`
 */
export const useWatchDexUnspecifiedCollateralEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'UnspecifiedCollateral',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"UnwindCompleted"`
 */
export const useWatchDexUnwindCompletedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'UnwindCompleted',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"UnwindContractTrigger"`
 */
export const useWatchDexUnwindContractTriggerEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'UnwindContractTrigger',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"UnwindInitializationCleared"`
 */
export const useWatchDexUnwindInitializationClearedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'UnwindInitializationCleared',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"UnwindInitialized"`
 */
export const useWatchDexUnwindInitializedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'UnwindInitialized',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"UnwindInsufficientBalance"`
 */
export const useWatchDexUnwindInsufficientBalanceEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'UnwindInsufficientBalance',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"UnwindIterationCompleted"`
 */
export const useWatchDexUnwindIterationCompletedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'UnwindIterationCompleted',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"UnwindPreparationCleared"`
 */
export const useWatchDexUnwindPreparationClearedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'UnwindPreparationCleared',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"UnwindPrepared"`
 */
export const useWatchDexUnwindPreparedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'UnwindPrepared',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"UnwindProcessInProgress"`
 */
export const useWatchDexUnwindProcessInProgressEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'UnwindProcessInProgress',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"UpdateOracleFailed"`
 */
export const useWatchDexUpdateOracleFailedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'UpdateOracleFailed',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"Upgraded"`
 */
export const useWatchDexUpgradedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'Upgraded',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"ValueExceedsMaximum"`
 */
export const useWatchDexValueExceedsMaximumEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'ValueExceedsMaximum',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"WRLSMinWithdrawLimitUpdated"`
 */
export const useWatchDexWrlsMinWithdrawLimitUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'WRLSMinWithdrawLimitUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"WRLSThousandthsTvlUpdated"`
 */
export const useWatchDexWrlsThousandthsTvlUpdatedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'WRLSThousandthsTvlUpdated',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"WhitelistAddress"`
 */
export const useWatchDexWhitelistAddressEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'WhitelistAddress',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"WhitelistingEnabledChanged"`
 */
export const useWatchDexWhitelistingEnabledChangedEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'WhitelistingEnabledChanged',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"WithdrawRateLimitBypassSet"`
 */
export const useWatchDexWithdrawRateLimitBypassSetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'WithdrawRateLimitBypassSet',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"WithdrawRateLimitForceReset"`
 */
export const useWatchDexWithdrawRateLimitForceResetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'WithdrawRateLimitForceReset',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"WithdrawRateLimitReset"`
 */
export const useWatchDexWithdrawRateLimitResetEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'WithdrawRateLimitReset',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link dexAbi}__ and `eventName` set to `"WrongAccountForOrder"`
 */
export const useWatchDexWrongAccountForOrderEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: dexAbi,
    eventName: 'WrongAccountForOrder',
  })

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20AbIsAbi}__
 */
export const useReadErc20AbIs = /*#__PURE__*/ createUseReadContract({
  abi: erc20AbIsAbi,
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20AbIsAbi}__ and `functionName` set to `"allowance"`
 */
export const useReadErc20AbIsAllowance = /*#__PURE__*/ createUseReadContract({
  abi: erc20AbIsAbi,
  functionName: 'allowance',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20AbIsAbi}__ and `functionName` set to `"balanceOf"`
 */
export const useReadErc20AbIsBalanceOf = /*#__PURE__*/ createUseReadContract({
  abi: erc20AbIsAbi,
  functionName: 'balanceOf',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20AbIsAbi}__ and `functionName` set to `"decimals"`
 */
export const useReadErc20AbIsDecimals = /*#__PURE__*/ createUseReadContract({
  abi: erc20AbIsAbi,
  functionName: 'decimals',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20AbIsAbi}__ and `functionName` set to `"name"`
 */
export const useReadErc20AbIsName = /*#__PURE__*/ createUseReadContract({
  abi: erc20AbIsAbi,
  functionName: 'name',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20AbIsAbi}__ and `functionName` set to `"symbol"`
 */
export const useReadErc20AbIsSymbol = /*#__PURE__*/ createUseReadContract({
  abi: erc20AbIsAbi,
  functionName: 'symbol',
})

/**
 * Wraps __{@link useReadContract}__ with `abi` set to __{@link erc20AbIsAbi}__ and `functionName` set to `"totalSupply"`
 */
export const useReadErc20AbIsTotalSupply = /*#__PURE__*/ createUseReadContract({
  abi: erc20AbIsAbi,
  functionName: 'totalSupply',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc20AbIsAbi}__
 */
export const useWriteErc20AbIs = /*#__PURE__*/ createUseWriteContract({
  abi: erc20AbIsAbi,
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc20AbIsAbi}__ and `functionName` set to `"approve"`
 */
export const useWriteErc20AbIsApprove = /*#__PURE__*/ createUseWriteContract({
  abi: erc20AbIsAbi,
  functionName: 'approve',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc20AbIsAbi}__ and `functionName` set to `"transfer"`
 */
export const useWriteErc20AbIsTransfer = /*#__PURE__*/ createUseWriteContract({
  abi: erc20AbIsAbi,
  functionName: 'transfer',
})

/**
 * Wraps __{@link useWriteContract}__ with `abi` set to __{@link erc20AbIsAbi}__ and `functionName` set to `"transferFrom"`
 */
export const useWriteErc20AbIsTransferFrom =
  /*#__PURE__*/ createUseWriteContract({
    abi: erc20AbIsAbi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc20AbIsAbi}__
 */
export const useSimulateErc20AbIs = /*#__PURE__*/ createUseSimulateContract({
  abi: erc20AbIsAbi,
})

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc20AbIsAbi}__ and `functionName` set to `"approve"`
 */
export const useSimulateErc20AbIsApprove =
  /*#__PURE__*/ createUseSimulateContract({
    abi: erc20AbIsAbi,
    functionName: 'approve',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc20AbIsAbi}__ and `functionName` set to `"transfer"`
 */
export const useSimulateErc20AbIsTransfer =
  /*#__PURE__*/ createUseSimulateContract({
    abi: erc20AbIsAbi,
    functionName: 'transfer',
  })

/**
 * Wraps __{@link useSimulateContract}__ with `abi` set to __{@link erc20AbIsAbi}__ and `functionName` set to `"transferFrom"`
 */
export const useSimulateErc20AbIsTransferFrom =
  /*#__PURE__*/ createUseSimulateContract({
    abi: erc20AbIsAbi,
    functionName: 'transferFrom',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc20AbIsAbi}__
 */
export const useWatchErc20AbIsEvent = /*#__PURE__*/ createUseWatchContractEvent(
  { abi: erc20AbIsAbi },
)

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc20AbIsAbi}__ and `eventName` set to `"Approval"`
 */
export const useWatchErc20AbIsApprovalEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: erc20AbIsAbi,
    eventName: 'Approval',
  })

/**
 * Wraps __{@link useWatchContractEvent}__ with `abi` set to __{@link erc20AbIsAbi}__ and `eventName` set to `"Transfer"`
 */
export const useWatchErc20AbIsTransferEvent =
  /*#__PURE__*/ createUseWatchContractEvent({
    abi: erc20AbIsAbi,
    eventName: 'Transfer',
  })
